<template>
  <v-container class="ma-0 px-0" :style="`min-width:100vw; min-height:100vh; background-position:top center; background-size:initial; background-repeat: repeat; background-image:url('${require('../../assets/dark parchment background.jpg')};`">
    <v-card class="mx-auto my-8" max-width="1680" dark :style="`background-position:top center; background-size:initial; background-repeat: repeat; background-image:url('${require('../../assets/big_bar_bg.png')}; border-radius: 6px; border-style:solid; border-color:saddlebrown; border-width:2px;`">      
      <v-card-text>
        <v-tabs v-model="tab" background-color="#654321" dark fixed-tabs>
          <v-tab v-for="item in tabs" :key="item.id">
            {{ item.name }}
          </v-tab>
        </v-tabs>
        <!-- B69B79 -->
        <v-tabs-items v-model="tab" style="background-color:transparent;">
          <v-tab-item>
            <!-- Ability Scores Tab -->
            <v-container>
              <h2 class="text-h4 mb-4">Abilities</h2>
              <v-row>
                <v-col v-for="(ability, key) in characterData.abilities" :key="key" cols="4">
                  <v-card outlined class="pa-3 text-center mb-3" style="background-color:#FFECC9;">
                    <div class="text-h6 mb-2">
                      {{ getAbilityName(key) }} <br/>
                      <v-tooltip bottom :open-delay="250">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" style="font-size:1.5em; cursor:help;">
                            <span v-if="characterData.abilities[key].modifiedScore > 11">+</span>{{characterData.abilities[key].modifiedModifier}}
                          </span>
                        </template>
                        <div style="font-size:13px; line-height:1.6; min-width:150px;">
                          <div v-for="(line, index) in getAbilityScoreBreakdown(key)" :key="index">{{ line }}</div>
                          <div style="border-top:1px solid rgba(255,255,255,0.4); margin-top:3px; padding-top:3px; font-weight:bold;">
                            {{ characterData.abilities[key].modifiedScore }} total
                          </div>
                        </div>
                      </v-tooltip>
                    </div>
                    
                    <!-- Score and Modifier Row -->
                    <v-row>
                      <div style="font-size: 1.5em; align-items: center; justify-content: center; display: flex; margin-top: 16px; margin-left: 6px;margin-right: -6px;width:42px">(<span v-if="characterData.abilities[key].score > 11">+</span>{{Math.floor((characterData.abilities[key].score-10)/2)}})</div>
                      <v-col cols="6">
                        <v-text-field
                          v-model="characterData.abilities[key].score"
                          label="Score"
                          type="number"
                          hide-details
                          class="text-center"
                          @change="updateAbilityModifier(key)"
                        ></v-text-field>
                      </v-col>
                      <v-divider vertical></v-divider>
                      <v-col cols="4">
                        <v-text-field
                          v-model="characterData.abilities[key].modifiedScore"
                          label="Modified Score"
                          type="number"
                          hide-details
                          class="text-center"
                          readonly
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    
                    <!-- Damage, Drain, Burn, Wither Row -->
                    <v-row>
                      <v-col cols="4">
                      <v-text-field
                          v-model="characterData.abilities[key].bonus"
                          label="Bonus"
                          type="number"
                          hide-details
                          class="text-center"
                          @change="updateAllModifiedScores()"
                          min="0"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          v-model="characterData.abilities[key].damage"
                          label="Damage"
                          type="number"
                          hide-details
                          class="text-center"
                          @change="updateAllModifiedScores()"
                          min="0"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          v-model="characterData.abilities[key].drain"
                          label="Drain"
                          type="number"
                          hide-details
                          class="text-center"
                          @change="updateAllModifiedScores()"
                          min="0"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    
                    <!-- Modified Score and Modified Modifier Row -->
                    <v-row>
                      <v-col cols="4">
                        <v-text-field
                          v-model="characterData.abilities[key].burn"
                          label="Burn"
                          type="number"
                          hide-details
                          class="text-center"
                          @change="updateAllModifiedScores()"
                          min="0"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          v-model="characterData.abilities[key].wither"
                          label="Wither"
                          type="number"
                          hide-details
                          class="text-center"
                          @change="updateAllModifiedScores()"
                          min="0"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          v-model="characterData.abilities[key].permanent"
                          label="Permanent"
                          type="number"
                          hide-details
                          class="text-center"
                          @change="updateAllModifiedScores()"
                          min="0"
                          ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          
          <v-tab-item>
            <!-- Defense Tab -->
            <v-container>
              <h2 class="text-h4 mb-4">Defense</h2>

                             <!-- HP Section -->
               <v-row>
                 <v-col cols="12">
                   <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                     <div class="text-h6 mb-3">Health</div>
                    <v-row>
                      <v-col cols="3">
                        <v-text-field
                          v-model="effectiveHpMax"
                          label="Max Hit Points"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model="effectiveHpCurrent"
                          label="Current"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                        <v-text-field
                          v-model="characterData.defense.hp.temp"
                          label="Temporary"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model="characterData.defense.hp.nonLethal"
                          label="Non-Lethal Damage"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model="characterData.defense.hp.delayed"
                          label="Delayed Damage"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                        <v-text-field
                          v-model="characterData.defense.hp.delayedMax"
                          label="Delayed Max"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
              
                             <!-- Armor Class Section -->
               <v-row>
                 <v-col cols="12">
                   <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                     <div class="text-h6 mb-3">AC (Armor Class)</div>
                    <v-row>
                      <v-col cols="4">
                        <v-text-field
                          :value="acTotal"
                          label="Total"
                          type="number"
                          hide-details
                          class="text-center"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          :value="acTouch"
                          label="Touch"
                          type="number"
                          hide-details
                          class="text-center"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          :value="acFlatFooted"
                          label="Flat-Footed"
                          type="number"
                          hide-details
                          class="text-center"
                          readonly
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.defense.ac.armorBonus"
                          label="Armor Bonus"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.defense.ac.shieldBonus"
                          label="Shield Bonus"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-menu offset-y :close-on-content-click="false">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="getTotalACModifier()"
                              label="AC Modifiers"
                              type="number"
                              hide-details
                              class="text-center"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              style="cursor: pointer;"
                            ></v-text-field>
                          </template>
                          <v-list dense>
                            <v-list-item>
                              <v-list-item-content>
                                <v-row align="center" no-gutters>
                                  <v-col cols="8">
                                    <v-list-item-title>Select AC Modifiers</v-list-item-title>
                                  </v-col>
                                  <v-col cols="4">
                                    <v-text-field
                                      v-model="characterData.defense.ac.maxDex"
                                      label="Max Dex"
                                      type="number"
                                      min="0"
                                      placeholder="None"
                                      clearable
                                      hide-details
                                      dense
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item v-for="ability in ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma']" :key="ability">
                              <v-list-item-content>
                                <v-row align="center">
                                  <v-col cols="8">
                                    <v-checkbox
                                      :input-value="isAbilityModifierEnabled(characterData.defense.ac.statModifiers[ability])"
                                      @change="setAbilityModifierEnabled(characterData.defense.ac.statModifiers, ability, $event)"
                                      :label="`${ability.charAt(0).toUpperCase() + ability.slice(1)} (${characterData.abilities[ability].modifiedModifier})`"
                                      hide-details
                                      dense
                                    ></v-checkbox>
                                  </v-col>
                                  <v-col cols="4">
                                    <v-text-field
                                      :value="getAbilityModifierMultiplier(characterData.defense.ac.statModifiers[ability])"
                                      @input="setAbilityModifierMultiplier(characterData.defense.ac.statModifiers, ability, $event)"
                                      label="Mult"
                                      type="number"
                                      step="0.5"
                                      min="0"
                                      hide-details
                                      dense
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      <v-col cols="2">
                        <v-menu offset-y :close-on-content-click="false">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="getSpecialACModifier()"
                              label="Special AC Modifiers"
                              type="number"
                              hide-details
                              class="text-center"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              style="cursor: pointer;"
                            ></v-text-field>
                          </template>
                          <v-list dense>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Select Special Ability Modifiers <br/>(also applies to touch and flat-footed)</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item v-for="ability in ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma']" :key="ability">
                              <v-list-item-content>
                                <v-row align="center">
                                  <v-col cols="8">
                                    <v-checkbox
                                      :input-value="isAbilityModifierEnabled(characterData.defense.ac.specialAbilityModifiers[ability])"
                                      @change="setAbilityModifierEnabled(characterData.defense.ac.specialAbilityModifiers, ability, $event)"
                                      :label="`${ability.charAt(0).toUpperCase() + ability.slice(1)} (${characterData.abilities[ability].modifiedModifier})`"
                                      hide-details
                                      dense
                                    ></v-checkbox>
                                  </v-col>
                                  <v-col cols="4">
                                    <v-text-field
                                      :value="getAbilityModifierMultiplier(characterData.defense.ac.specialAbilityModifiers[ability])"
                                      @input="setAbilityModifierMultiplier(characterData.defense.ac.specialAbilityModifiers, ability, $event)"
                                      label="Mult"
                                      type="number"
                                      step="0.5"
                                      min="0"
                                      hide-details
                                      dense
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.defense.ac.dodgeBonus"
                          label="Dodge Bonus"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.defense.ac.enhancedNaturalArmor"
                          label="Enhanced Natural"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.defense.ac.deflection"
                          label="Deflection"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.defense.ac.naturalArmor"
                          label="Natural Armor"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.defense.ac.sizeModifier"
                          label="Size Modifier"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.defense.ac.miscModifier"
                          label="Misc Modifier"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.defense.ac.untypedBonus"
                          label="Untyped Bonus"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.defense.ac.insightBonus"
                          label="Insight Bonus"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.defense.ac.moraleBonus"
                          label="Morale Bonus"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.defense.ac.profaneBonus"
                          label="Profane Bonus"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.defense.ac.sacredBonus"
                          label="Sacred Bonus"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="characterData.defense.ac.otherModifiers"
                          label="Other AC Modifiers"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>

              
              <!-- DR and SR Section -->
              <v-row>
                <v-col cols="6">
                  <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                    <div class="text-h6 mb-3">DR (Damage Reduction)</div>
                    <v-text-field
                      v-model="characterData.defense.dr"
                      label="DR Damage Reduction"
                      :suffix="drBuffSuffix"
                      hide-details
                    ></v-text-field>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                    <div class="text-h6 mb-3">SR (Spell Resistance)</div>
                    <v-text-field
                      v-model="characterData.defense.sr"
                      label="SR Spell Resistance"
                      hide-details
                    ></v-text-field>
                  </v-card>
                </v-col>
              </v-row>
              
              <!-- Saving Throws Section -->
              <v-row>
                <v-col cols="12">
                  <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                    <div class="text-h6 mb-3">Saving Throws</div>
                    <v-row v-for="(save, key) in characterData.defense.saves" :key="key">
                      <v-col cols="12">
                        <div class="text-subtitle-1 mb-2">{{ getSaveName(key) }}</div>
                        <v-row>
                          <v-col cols="2">
                            <v-text-field
                              :value="saveTotals[key]"
                              label="Total"
                              type="number"
                              hide-details
                              class="text-center"
                              readonly
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field
                              v-model="characterData.defense.saves[key].baseSave"
                              label="Base Save"
                              type="number"
                              hide-details
                              class="text-center"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-menu offset-y :close-on-content-click="false">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  :value="getTotalSaveAbilityModifier(key)"
                                  label="Ability Modifiers"
                                  type="number"
                                  hide-details
                                  class="text-center"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  style="cursor: pointer;"
                                ></v-text-field>
                              </template>
                              <v-list dense>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>Select Save Ability Modifiers</v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item v-for="ability in ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma']" :key="ability">
                                  <v-list-item-content>
                                    <v-row align="center">
                                      <v-col cols="8">
                                        <v-checkbox
                                          :input-value="isAbilityModifierEnabled(characterData.defense.saves[key].abilityModifiers[ability])"
                                          @change="setAbilityModifierEnabled(characterData.defense.saves[key].abilityModifiers, ability, $event)"
                                          :label="`${ability.charAt(0).toUpperCase() + ability.slice(1)} (${characterData.abilities[ability].modifiedModifier})`"
                                          hide-details
                                          dense
                                        ></v-checkbox>
                                      </v-col>
                                      <v-col cols="4">
                                        <v-text-field
                                          :value="getAbilityModifierMultiplier(characterData.defense.saves[key].abilityModifiers[ability])"
                                          @input="setAbilityModifierMultiplier(characterData.defense.saves[key].abilityModifiers, ability, $event)"
                                          label="Mult"
                                          type="number"
                                          step="0.5"
                                          min="0"
                                          hide-details
                                          dense
                                        ></v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field
                              v-model="characterData.defense.saves[key].magicModifier"
                              label="Magic Modifier"
                              type="number"
                              hide-details
                              class="text-center"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field
                              v-model="characterData.defense.saves[key].miscModifier"
                              label="Misc Modifier"
                              type="number"
                              hide-details
                              class="text-center"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field
                              v-model="characterData.defense.saves[key].tempModifier"
                              label="Temp Modifier"
                              type="number"
                              hide-details
                              class="text-center"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              v-model="characterData.defense.saves[key].otherModifiers"
                              label="Other Modifiers"
                              hide-details
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
              
              <!-- Resist, Immune, CMD Section -->
              <v-row>
                <v-col cols="4">
                  <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                    <div class="text-h6 mb-3">Resistances</div>
                    <v-text-field
                      v-model="characterData.defense.resist.specific"
                      label="Specific Resistance"
                      hide-details
                    ></v-text-field>
                    <v-text-field
                      v-model="characterData.defense.resist.elemental"
                      label="Elemental & Other"
                      hide-details
                    ></v-text-field>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                    <div class="text-h6 mb-3">Immunities</div>
                    <v-text-field
                      v-model="characterData.defense.immune.specific"
                      label="Specific Immunity"
                      hide-details
                    ></v-text-field>
                    <v-text-field
                      v-model="characterData.defense.immune.effects"
                      label="Effects & Other"
                      hide-details
                    ></v-text-field>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                    <div class="text-h6 mb-3">Combat Maneuver Defense (CMD)</div>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field
                          :value="cmdTotal"
                          label="Total"
                          type="number"
                          hide-details
                          class="text-center"
                          readonly
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field
                          v-model="characterData.offense.bab"
                          label="Base Attack Bonus"
                          hide-details
                          readonly
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-menu offset-y :close-on-content-click="false">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="getTotalCMDStrModifier()"
                              label="CMD Ability Modifiers"
                              type="number"
                              hide-details
                              class="text-center"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              style="cursor: pointer;"
                            ></v-text-field>
                          </template>
                          <v-list dense>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Ability Modifiers</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item v-for="ability in ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma']" :key="ability">
                              <v-list-item-content>
                                <v-row align="center">
                                  <v-col cols="8">
                                    <v-checkbox
                                      :input-value="isAbilityModifierEnabled(characterData.defense.cmd.statModifiers[ability])"
                                      @change="setAbilityModifierEnabled(characterData.defense.cmd.statModifiers, ability, $event)"
                                      :label="`${ability.charAt(0).toUpperCase() + ability.slice(1)} (${characterData.abilities[ability].modifiedModifier})`"
                                      hide-details
                                      dense
                                    ></v-checkbox>
                                  </v-col>
                                  <v-col cols="4">
                                    <v-text-field
                                      :value="getAbilityModifierMultiplier(characterData.defense.cmd.statModifiers[ability])"
                                      @input="setAbilityModifierMultiplier(characterData.defense.cmd.statModifiers, ability, $event)"
                                      label="Mult"
                                      type="number"
                                      step="0.5"
                                      min="0"
                                      hide-details
                                      dense
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>                      
                      <v-col cols="6">
                        <v-text-field
                          v-model="characterData.defense.cmd.sizeModifier"
                          label="Size Modifier"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="characterData.defense.cmd.miscModifiers"
                          label="Misc Modifiers"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>                      
                      <v-col cols="12">
                        <v-text-field
                          v-model="characterData.defense.cmd.tempModifiers"
                          label="Temp Modifiers"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          
          <v-tab-item>
            <!-- Offense Tab -->
            <v-container>
              <h2 class="text-h4 mb-4">Offense</h2>
              
              <!-- Initiative Section -->
              <v-row>
                <v-col cols="12">
                  <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                    <v-row>
                      <v-col cols="6">
                        <div class="text-h6 mb-3">Initiative:</div>
                        <v-row>
                          <v-col cols="2">
                            <v-text-field
                              :value="getTotalInitiative()"
                              label="Total ="
                              type="number"
                              hide-details
                              class="text-center"
                              readonly
                            ></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-menu offset-y :close-on-content-click="false">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  :value="getTotalInitiativeAbilityModifier()"
                                  label="Ability Modifiers"
                                  type="number"
                                  hide-details
                                  class="text-center"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  style="cursor: pointer;"
                                ></v-text-field>
                              </template>
                              <v-list dense>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>Select Initiative Ability Modifiers</v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item v-for="ability in ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma']" :key="ability">
                                  <v-list-item-content>
                                    <v-row align="center">
                                      <v-col cols="8">
                                        <v-checkbox
                                          :input-value="isAbilityModifierEnabled(characterData.offense.initiative.abilityModifiers[ability])"
                                          @change="setAbilityModifierEnabled(characterData.offense.initiative.abilityModifiers, ability, $event)"
                                          :label="`${ability.charAt(0).toUpperCase() + ability.slice(1)} (${characterData.abilities[ability].modifiedModifier})`"
                                          hide-details
                                          dense
                                        ></v-checkbox>
                                      </v-col>
                                      <v-col cols="4">
                                        <v-text-field
                                          :value="getAbilityModifierMultiplier(characterData.offense.initiative.abilityModifiers[ability])"
                                          @input="setAbilityModifierMultiplier(characterData.offense.initiative.abilityModifiers, ability, $event)"
                                          label="Mult"
                                          type="number"
                                          step="0.5"
                                          min="0"
                                          hide-details
                                          dense
                                        ></v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-col>
                          <v-col cols="3">
                            <v-text-field
                              v-model="characterData.offense.initiative.miscModifiers"
                              label="Misc Modifiers"
                              hide-details
                              class="text-center"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field
                              v-model="characterData.offense.initiative.modifiersNotes"
                              label="Modifiers & Notes"
                              hide-details
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <div class="text-h6 mb-3">BAB (Base Attack Bonus):</div>
                            <v-row>
                              <v-col cols="12">
                                <v-text-field
                                  v-model="characterData.offense.bab"
                                  label="Base Attack Bonus"
                                  hide-details
                                  class="text-center"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                     <v-col cols="6">
                       <div class="text-h6 mb-3">Movement:</div>
                       <v-row>
                         <v-col cols="2">
                           <v-text-field
                             v-model="characterData.offense.speed.base"
                             label="Base Speed"
                             type="number"
                             hide-details
                             class="text-center"
                             dense
                           ></v-text-field>
                         </v-col>
                         <v-col cols="2">
                           <v-text-field
                             v-model="characterData.offense.speed.withArmor"
                             label="With Armor"
                             type="number"
                             hide-details
                             class="text-center"
                             dense
                           ></v-text-field>
                         </v-col>
                         <v-col cols="2">
                           <v-text-field
                             v-model="characterData.offense.speed.fly"
                             label="Fly/Maneuverability"
                             hide-details
                             class="text-center"
                             dense
                           ></v-text-field>
                         </v-col>
                         <v-col cols="2">
                           <v-text-field
                             v-model="characterData.offense.speed.swim"
                             label="Swim"
                             type="number"
                             hide-details
                             class="text-center"
                             dense
                           ></v-text-field>
                         </v-col>
                         <v-col cols="2">
                           <v-text-field
                             v-model="characterData.offense.speed.climb"
                             label="Climb"
                             type="number"
                             hide-details
                             class="text-center"
                             dense
                           ></v-text-field>
                         </v-col>
                         <v-col cols="2">
                           <v-text-field
                             v-model="characterData.offense.speed.burrow"
                             label="Burrow"
                             type="number"
                             hide-details
                             class="text-center"
                             dense
                           ></v-text-field>
                         </v-col>
                       </v-row>
                       <v-row>
                         
                       </v-row>
                       <v-row>
                         <v-col cols="12">
                           <v-text-field
                             v-model="characterData.offense.speed.tempModifiers"
                             label="Temp Modifiers"
                             hide-details
                             dense
                           ></v-text-field>
                         </v-col>
                       </v-row>
                     </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
              
              <!-- Attack Bonus Configuration Section -->
              <v-row>
                <v-col cols="12">
                  <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                    <div class="text-h6 mb-3">General Attack Bonus</div>
                    
                    <!-- Ability Modifiers Row -->
                    <v-row>
                      <v-col cols="2">
                        <v-text-field
                           :value="getTotalAttackBonus()"
                           label="Total"
                           type="number"
                           hide-details
                           class="text-center"
                           readonly
                         ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-menu offset-y :close-on-content-click="false">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="getTotalAttackAbilityModifier()"
                              label="Ability Modifiers"
                              type="number"
                              hide-details
                              class="text-center"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              style="cursor: pointer;"
                            ></v-text-field>
                          </template>
                          <v-list dense>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Select Attack Ability Modifiers</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item v-for="ability in ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma']" :key="ability">
                              <v-list-item-content>
                                <v-row align="center">
                                  <v-col cols="8">
                                    <v-checkbox
                                      :input-value="isAbilityModifierEnabled(characterData.offense.attackBonus.abilityModifiers[ability])"
                                      @change="setAbilityModifierEnabled(characterData.offense.attackBonus.abilityModifiers, ability, $event)"
                                      :label="`${ability.charAt(0).toUpperCase() + ability.slice(1)} (${characterData.abilities[ability].modifiedModifier})`"
                                      hide-details
                                      dense
                                    ></v-checkbox>
                                  </v-col>
                                  <v-col cols="4">
                                    <v-text-field
                                      :value="getAbilityModifierMultiplier(characterData.offense.attackBonus.abilityModifiers[ability])"
                                      @input="setAbilityModifierMultiplier(characterData.offense.attackBonus.abilityModifiers, ability, $event)"
                                      label="Mult"
                                      type="number"
                                      step="0.5"
                                      min="0"
                                      hide-details
                                      dense
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.offense.attackBonus.enhancementBonus"
                          label="Enhancement Bonus"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.offense.attackBonus.luckBonus"
                          label="Luck Bonus"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.offense.attackBonus.moraleBonus"
                          label="Morale Bonus"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                       <v-col cols="2">
                        <v-text-field
                          v-model="characterData.offense.attackBonus.competenceBonus"
                          label="Competence Bonus"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    
                    <!-- Third Row -->
                    <v-row>
                       <v-col cols="2">
                        <v-text-field
                          v-model="characterData.offense.attackBonus.insightBonus"
                          label="Insight Bonus"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.offense.attackBonus.untypedBonus"
                          label="Untyped Bonus"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.offense.attackBonus.sizeModifier"
                          label="Size Modifier"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.offense.attackBonus.profaneBonus"
                          label="Profane Bonus"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.offense.attackBonus.sacredBonus"
                          label="Sacred Bonus"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.offense.attackBonus.miscModifiers"
                          label="Misc Modifiers"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    
                    <!-- Fifth Row -->
                    <v-row>
                      <v-col cols="10">
                        <v-text-field
                          v-model="characterData.offense.attackBonus.tempModifiers"
                          label="Temp Modifiers"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.offense.attackBonus.criticalConfirmBonus"
                          label="Crit Confirmation Bonus"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Damage Bonus Configuration Section -->
              <v-row>
                <v-col cols="12">
                  <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                    <div class="text-h6 mb-3">Damage Bonus Configuration</div>
                    
                    <!-- Add/Remove Damage Bonus Entries -->
                    <v-row class="mb-3">
                      <v-col cols="12">
                        <v-btn 
                          color="primary" 
                          small 
                          @click="addDamageBonus"
                          class="mr-2"
                        >
                          <v-icon left>mdi-plus</v-icon>
                          Add Damage Bonus
                        </v-btn>
                      </v-col>
                    </v-row>

                    <!-- Damage Bonus Entries -->
                    <div v-for="(damageBonus, index) in characterData.offense.damageBonuses" :key="index" class="mb-4">
                      <v-card outlined class="pa-3" style="background-color:#FFF8E1;">
                        <div style="position: absolute; top: -6px; left: -6px; min-width: 20px; width: 20px; height: 20px;">
                          <v-btn icon small @click="copyDamageBonusToClipboard(damageBonus)">
                            <v-icon>mdi-dice-d20</v-icon>
                          </v-btn>
                        </div>
                        <v-row class="mb-2">
                          <v-col cols="3">
                            <v-text-field
                              v-model="damageBonus.name"
                              label="Damage Bonus Name"
                              hide-details
                              placeholder="e.g., Melee Attack, Ranged Attack, etc."
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field
                              :value="getTotalDamageBonus(index)"
                              label="Total"
                              hide-details
                              readonly
                            ></v-text-field>
                          </v-col>

                          <v-col cols="7" class="text-right">
                            <v-btn 
                              color="error" 
                              icon 
                              small 
                              @click="removeDamageBonus(index)"
                              :disabled="characterData.offense.damageBonuses.length <= 1"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                        

                        <!-- Basic Damage Info Row -->
                        <v-row class="mt-1">
                          <v-col cols="1">
                            <v-menu offset-y :close-on-content-click="false">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  :value="getTotalDamageAbilityModifier(index)"
                                  label="Ability Modifiers"
                                  type="number"
                                  hide-details
                                  class="text-center"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  style="cursor: pointer;"
                                  dense
                                ></v-text-field>
                              </template>
                              <v-list dense>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>Select Damage Ability Modifiers</v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item v-for="ability in ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma']" :key="ability">
                                  <v-list-item-content>
                                    <v-row align="center">
                                      <v-col cols="8">
                                        <v-checkbox
                                          v-model="damageBonus.abilityModifiers[ability].modifies"
                                          :label="`${ability.charAt(0).toUpperCase() + ability.slice(1)} (${characterData.abilities[ability].modifiedModifier})`"
                                          hide-details
                                          dense
                                        ></v-checkbox>
                                      </v-col>
                                      <v-col cols="4">
                                        <v-text-field
                                          v-model="damageBonus.abilityModifiers[ability].multiplier"
                                          label="Mult"
                                          type="number"
                                          step="0.5"
                                          min="0"
                                          max="5"
                                          hide-details
                                          dense
                                          class="text-center"
                                        ></v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field
                              dense
                              v-model="damageBonus.dice"
                              label="Base Dice"
                              hide-details
                              class="text-center"
                              placeholder="2d6+1d8"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field
                              dense
                              v-model="damageBonus.nonMultipliedDamage"
                              label="Non-Multiplied Dice"
                              hide-details
                              class="text-center"
                              placeholder="1d6+1"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                          <v-text-field
                              dense
                              v-model="damageBonus.precision"
                              label="Precision"
                              hide-details
                              class="text-center"
                              placeholder="3d6"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field
                              dense
                              v-model="damageBonus.bonusCriticalDamage"
                              label="Bonus Critical Damage"
                              hide-details
                              class="text-center"
                              placeholder="1d6+1"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field
                              v-model="damageBonus.type"
                              label="Damage Type(s)"
                              hide-details
                              class="text-center"
                              dense
                              placeholder="Slashing"
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <!-- Bonus Modifiers Row 1 -->
                        <v-row>
                          <v-col cols="1">
                            <v-text-field
                              v-model="damageBonus.enhancementBonus"
                              label="Enhancement"
                              type="number"
                              hide-details
                              class="text-center"
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="1">
                            <v-text-field
                              v-model="damageBonus.moraleBonus"
                              label="Morale"
                              type="number"
                              hide-details
                              class="text-center"
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="1">
                            <v-text-field
                              v-model="damageBonus.luckBonus"
                              label="Luck"
                              type="number"
                              hide-details
                              class="text-center"
                              dense
                            ></v-text-field>
                          </v-col>   
                          <v-col cols="1">
                            <v-text-field
                              v-model="damageBonus.competenceBonus"
                              label="Competence"
                              type="number"
                              hide-details
                              class="text-center"
                              dense
                            ></v-text-field>
                          </v-col>                       
                          <v-col cols="1">
                            <v-text-field
                              v-model="damageBonus.insightBonus"
                              label="Insight"
                              type="number"
                              hide-details
                              class="text-center"
                              dense
                            ></v-text-field>
                          </v-col>                 
                          <v-col cols="1">
                            <v-text-field
                              v-model="damageBonus.feat"
                              label="Feat"
                              type="number"
                              hide-details
                              class="text-center"
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="1">
                            <v-text-field
                              v-model="damageBonus.profaneBonus"
                              label="Profane"
                              type="number"
                              hide-details
                              class="text-center"
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="1">
                            <v-text-field
                              v-model="damageBonus.sacredBonus"
                              label="Sacred"
                              type="number"
                              hide-details
                              class="text-center"
                              dense
                            ></v-text-field>
                          </v-col>    
                          <v-col cols="1">
                            <v-text-field
                              v-model="damageBonus.untypedBonus"
                              label="Untyped"
                              type="number"
                              hide-details
                              class="text-center"
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field
                              v-model="damageBonus.miscModifiers"
                              label="Misc Modifiers"
                              hide-details
                              class="text-center"
                              dense
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        

                        <!-- Bonus Modifiers Row 2 -->
                        <v-row>                          
                          <v-col cols="4">
                            <v-text-field
                              v-model="damageBonus.tempModifiers"
                              label="Temp Modifiers"
                              hide-details
                              class="text-center"
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="8">
                            <v-text-field
                              v-model="damageBonus.notes"
                              label="Notes"
                              hide-details
                              placeholder="Additional notes about this damage calculation"
                              dense
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card>
                    </div>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Attacks Section -->
              <v-row>
                <v-col cols="12">
                  <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                    <div class="text-h6 mb-3 mt-2">Attacks</div>

                    <div style="position: absolute; top: -2px; left: -6px; min-width: 20px; width: 20px; height: 20px;">
                      <v-btn icon  @click="openDiceSettings" style="position: relative;">
                        <v-icon>mdi-dice-d20</v-icon>
                        <span
                          v-if="getTotalDiceSettingsCount() > 0"
                          style="position: absolute; top: -6px; right: 3px; color: cyan; font-size: 12px; font-weight: bold;  line-height: 1; background-color:rgba(0, 0, 0, 0.9); border-radius: 50%; padding: 2px; width:16px"
                        >
                          {{ getTotalDiceSettingsCount() }}
                        </span>
                      </v-btn>
                    </div>
                    
                    <!-- Attack Headers -->
                    <v-row class="mb-1" dense style="margin-left:-8px">
                      <v-col cols="2">
                        <div class="text-subtitle-2 text-center">Weapon</div>
                      </v-col>
                      <v-col cols="2">
                        <div class="text-subtitle-2 text-center">Attack Bonus</div>
                      </v-col>
                      <v-col cols="2">
                        <div class="text-subtitle-2 text-center">Damage</div>
                      </v-col>
                      <v-col cols="0.5">
                        <div class="text-subtitle-2 text-center">Crit Range</div>
                      </v-col>
                      <v-col cols="0.5">
                        <div class="text-subtitle-2 text-center">Crit Multiplier</div>
                      </v-col>                      
                      <v-col cols="0.5">
                        <div class="text-subtitle-2 text-center">Type</div>
                      </v-col>
                      <v-col cols="2">
                        <div class="text-subtitle-2 text-center">Notes</div>
                      </v-col>
                      <v-col cols="1">
                        <div class="text-subtitle-2 text-center">Show in Q.N.</div>
                      </v-col>
                    </v-row>
                    
                    <!-- Attack Rows -->
                    <v-card outlined v-for="(attack, index) in characterData.offense.attacks" :key="index" class="mb-2 mt-0 mx-0 pa-0" style="position: relative; background-color: wheat;">
                      <div style="position: absolute; top: -6px; left: -6px; min-width: 20px; width: 20px; height: 20px;">
                          <v-btn icon small @click="copyAttackToClipboard(attack)">
                            <v-icon>mdi-dice-d20</v-icon>
                          </v-btn>
                        </div>
                      <v-row class="ma-0 pa-0">
                      <v-col cols="2">
                        <v-text-field
                          v-model="attack.weapon"
                          hide-details
                          class="text-center"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="attack.attackBonus"
                          hide-details
                          class="text-center"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-menu offset-y :close-on-content-click="false">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="getSelectedDamageText(attack.damageBonusName)"
                              :label="attack.damageBonusName || 'Select Damage'"
                              hide-details
                              class="text-center"
                              dense
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              style="cursor: pointer;"
                            ></v-text-field>
                          </template>
                          <v-list dense>
                            <v-list-item
                              v-for="(option, index) in damageBonusOptions"
                              :key="index"
                              @click="attack.damageBonusName = option.value"
                              :class="{ 'v-list-item--active': attack.damageBonusName === option.value }"
                            >
                              <v-list-item-content>
                                <v-list-item-title>{{ option.text }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      <v-col cols="0.5">
                        <v-text-field
                          v-model="attack.criticalRange"
                          hide-details
                          class="text-center"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="0.5">
                        <v-text-field
                          v-model="attack.criticalMult"
                          hide-details
                          class="text-center"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="0.5">
                        <v-text-field
                          v-model="attack.type"
                          hide-details
                          class="text-center"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="attack.notes"
                          hide-details
                          class="text-center"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="0.5" style="align-content: center;">
                        <v-checkbox
                          v-model="attack.showInDetails"
                          hide-details
                          dense
                          style="justify-self: center;"
                        ></v-checkbox>
                      </v-col>
                      <!-- Small delete button positioned at top right -->
                      <v-btn
                        icon
                        x-small
                        color="error"
                        @click="deleteAttack(index)"
                        style="position: absolute; top: 0; right: 0; z-index: 10; min-width: 20px; width: 20px; height: 20px;"
                      >
                        <v-icon x-small>mdi-close</v-icon>
                      </v-btn>
                      <v-col cols="12" class="mt-0 pt-0" no-gutters>
                        <!-- Temp Modifiers Row -->
                        <v-row>
                          <v-col cols="1"></v-col>
                          <v-col cols="5">
                            <v-text-field
                              v-model="attack.tempAttackModifiers"
                              label="Temp Attack Modifiers"
                              hide-details
                              dense
                              placeholder="+2 from bless, -1 from fatigue"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              v-model="attack.tempDamageModifiers"
                              label="Temp Damage Modifiers"
                              hide-details
                              dense
                              placeholder="+1d6 from flaming, +2 from rage"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    </v-card>
                    
                    <!-- Global Modifiers -->
                    <v-row class="mt-4">
                      <v-col cols="6">
                        <v-text-field
                          v-model="characterData.offense.globalAttackModifier"
                          label="Global Attack Modifier"
                          hide-details
                          dense
                          placeholder="+2 bless"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="characterData.offense.globalDamageModifier"
                          label="Global Damage Modifier"
                          hide-details
                          dense
                          placeholder="+1d6 fire"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    
                    <!-- Add Attack Button -->
                    <v-row>
                      <v-col cols="12" class="text-center">
                        <v-btn color="primary" @click="addAttack">
                          + Attack
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
              
              <!-- CMB Section -->
              <v-row>
                <v-col cols="12">
                  <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                    <div class="text-h6 mb-3">Combat Maneuver Bonus (CMB)</div>
                    <v-row style="margin-bottom: 12px;">
                      <v-col cols="2">
                        <v-text-field
                          :value="getTotalCMB()"
                          label="Total ="
                          type="number"
                          hide-details
                          class="text-center"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-menu offset-y :close-on-content-click="false">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="getTotalCMBAbilityModifier()"
                              label="Ability Modifiers"
                              type="number"
                              hide-details
                              class="text-center"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              style="cursor: pointer;"
                            ></v-text-field>
                          </template>
                          <v-list dense>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Select CMB Ability Modifiers</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item v-for="ability in ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma']" :key="ability">
                              <v-list-item-content>
                                <v-row align="center">
                                  <v-col cols="8">
                                    <v-checkbox
                                      :input-value="isAbilityModifierEnabled(characterData.offense.cmb.abilityModifiers[ability])"
                                      @change="setAbilityModifierEnabled(characterData.offense.cmb.abilityModifiers, ability, $event)"
                                      :label="`${ability.charAt(0).toUpperCase() + ability.slice(1)} (${characterData.abilities[ability].modifiedModifier})`"
                                      hide-details
                                      dense
                                    ></v-checkbox>
                                  </v-col>
                                  <v-col cols="4">
                                    <v-text-field
                                      :value="getAbilityModifierMultiplier(characterData.offense.cmb.abilityModifiers[ability])"
                                      @input="setAbilityModifierMultiplier(characterData.offense.cmb.abilityModifiers, ability, $event)"
                                      label="Mult"
                                      type="number"
                                      step="0.5"
                                      min="0"
                                      hide-details
                                      dense
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.offense.cmb.sizeModifier"
                          label="Size Modifier"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model="characterData.offense.cmb.miscModifiers"
                          label="Misc Modifiers"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model="characterData.offense.cmb.tempModifiers"
                          label="Temp Modifiers"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <div class="text-h6 mb-3">CMB 2:</div>
                    <v-row>
                      <v-col cols="2">
                        <v-text-field
                          :value="getTotalCMB2()"
                          label="Total ="
                          type="number"
                          hide-details
                          class="text-center"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-menu offset-y :close-on-content-click="false">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="getTotalCMB2AbilityModifier()"
                              label="Ability Modifiers"
                              type="number"
                              hide-details
                              class="text-center"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              style="cursor: pointer;"
                            ></v-text-field>
                          </template>
                          <v-list dense>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Select CMB2 Ability Modifiers</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item v-for="ability in ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma']" :key="ability">
                              <v-list-item-content>
                                <v-row align="center">
                                  <v-col cols="8">
                                    <v-checkbox
                                      :input-value="isAbilityModifierEnabled(characterData.offense.cmb2.abilityModifiers[ability])"
                                      @change="setAbilityModifierEnabled(characterData.offense.cmb2.abilityModifiers, ability, $event)"
                                      :label="`${ability.charAt(0).toUpperCase() + ability.slice(1)} (${characterData.abilities[ability].modifiedModifier})`"
                                      hide-details
                                      dense
                                    ></v-checkbox>
                                  </v-col>
                                  <v-col cols="4">
                                    <v-text-field
                                      :value="getAbilityModifierMultiplier(characterData.offense.cmb2.abilityModifiers[ability])"
                                      @input="setAbilityModifierMultiplier(characterData.offense.cmb2.abilityModifiers, ability, $event)"
                                      label="Mult"
                                      type="number"
                                      step="0.5"
                                      min="0"
                                      hide-details
                                      dense
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          v-model="characterData.offense.cmb2.sizeModifier"
                          label="Size Modifier"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model="characterData.offense.cmb2.miscModifiers"
                          label="Misc Modifiers"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model="characterData.offense.cmb2.tempModifiers"
                          label="Temp Modifiers"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
              
              
            </v-container>
          </v-tab-item>
          
          <v-tab-item>
            <!-- Skills Tab -->
            <v-container>
              <h2 class="text-h4 mb-4">Skills</h2>
              
              <!-- Adventuring Skills Section -->              
              <v-row v-for="skillType in ['adventuring', 'background']" :key="skillType">
                <v-col cols="12">
                  <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                    <div class="d-flex justify-space-between align-center mb-3">
                      <div class="text-h6">{{ skillType.charAt(0).toUpperCase() + skillType.slice(1) }} Skills</div>
                      <div class="text-subtitle-1">Total Ranks: {{ skillType === 'adventuring' ? adventuringRanks : backgroundRanks }}</div>
                    </div>
                    
                    <!-- Skills Table Headers -->
                    <v-row style="margin-bottom: 4px;">
                      <v-col cols="2">
                        <div class="text-subtitle-2 text-center">Skill Name</div>
                      </v-col>
                      <v-col cols="1" style="margin-right: 100px;">
                        <div class="text-subtitle-2 text-center">Total</div>
                      </v-col>
                      <v-col cols="1">
                        <div class="text-subtitle-2 text-center">Ability Modifier</div>
                      </v-col>
                      <v-col cols="1">
                        <div class="text-subtitle-2 text-center">Ranks</div>
                      </v-col>
                      <v-col cols="1">
                        <div class="text-subtitle-2 text-center">Magic</div>
                      </v-col>
                      <v-col cols="1">
                        <div class="text-subtitle-2 text-center">Racial/Trait</div>
                      </v-col>
                      <v-col cols="1">
                        <div class="text-subtitle-2 text-center">Misc</div>
                      </v-col>
                      <v-col cols="1">
                        <div class="text-subtitle-2 text-center">Temp</div>
                      </v-col>
                      <v-col cols="2">
                        <div class="text-subtitle-2 text-center">Notes</div>
                      </v-col>
                    </v-row>
                    
                    <!-- Adventuring Skills Rows -->
                    <v-row v-for="(skill, index) in characterData.skills[skillType]" :key="`${skillType}-${index}`" class="my-0 py-0" dense no-gutters style="position: relative;" >
                      <v-col cols="2" style="align-content: left;">
                        <div class="d-flex align-center mt-3">
                          <div v-if="index === 0" style="position: absolute; top: -12px; left: 0;">Class</div>
                            <v-checkbox
                            v-model="skill.classSkill"
                            hide-details
                            class="ma-0"
                          ></v-checkbox>
                          <div style="font-size: 16px; padding-top:6px">{{ skill.name }}</div>
                          <v-text-field
                            v-if="skill.needsSpecific"
                            v-model="skill.specific"
                            hide-details
                            dense
                            class="ml-2"
                            style="max-width: 100px;"
                          ></v-text-field>
                          <v-btn
                            v-if="skill.canAddMore"
                            icon
                            x-small
                            :color="isFirstInstance(skillType, skill.name, index) ? 'primary' : 'error'"
                            @click="isFirstInstance(skillType, skill.name, index) ? addSkillRow(skillType, skill.name) : removeSkillRow(skillType, index)"
                            class="ml-1"
                          >
                            <v-icon x-small>{{ isFirstInstance(skillType, skill.name, index) ? 'mdi-plus' : 'mdi-minus' }}</v-icon>
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col cols="1" style="margin-right: 100px; align-content: end;">
                        <div style="font-size: 20px; text-align: center; padding-right:12px; border-bottom: 1px solid #000; margin-right:12px; margin-left:12px; padding-bottom:2px;">{{utilities.calculateSkillsTotal(skill, characterData, buffPointTrackers)}}</div>
                      </v-col>
                      <v-col cols="1" class="px-3" style="align-content: end;">
                        <div class="text-center">
                          <!-- <div class="text-body-1" style="text-decoration: underline;">{{ characterData.abilities[skill.ability].modifiedModifier }}</div> -->
                          <v-menu offset-y :close-on-content-click="false">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-bind="attrs"
                                v-on="on"
                                hide-details
                                class="text-center"
                                style="cursor: pointer; "
                                :label="getSkillAbilityDisplayText(skill)"
                                :value="utilities.getTotalSkillAbilityModifier(skill, characterData)"
                                readonly
                                dense
                              ></v-text-field>
                            </template>
                            <v-list dense>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title>Select Skill Ability Modifiers</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-divider></v-divider>
                              <v-list-item v-for="ability in ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma']" :key="ability">
                                <v-list-item-content>
                                  <v-row align="center">
                                    <v-col cols="8">
                                      <div v-if="ability === skill.ability" style="position: absolute; top: 0; left: 36px; color: #666;" class="text-caption">(Default)</div>
                                      <v-checkbox
                                        v-model="skill.abilityModifiers[ability].modifies"
                                        :label="`${getAbilityShortName(ability)} (${characterData.abilities[ability].modifiedModifier})`"
                                        hide-details
                                        dense
                                      ></v-checkbox>
                                    </v-col>
                                    <v-col cols="4">
                                      <v-text-field
                                        v-model="skill.abilityModifiers[ability].multiplier"
                                        label="Mult"
                                        type="number"
                                        step="0.5"
                                        min="0"
                                        max="5"
                                        hide-details
                                        dense
                                        class="text-center"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                      </v-col>
                      <v-col cols="1" class="px-3">
                        <v-text-field
                          v-model="skill.ranks"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="1" class="px-3">
                        <v-text-field
                          v-model="skill.magic"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="1" class="px-3">
                        <v-text-field
                          v-model="skill.race_trait"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="1" class="px-3">
                        <v-text-field
                          v-model="skill.misc"
                          type="number"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="1" class="px-3">
                        <v-text-field
                          v-model="skill.temp"
                          type="text"
                          hide-details
                          class="text-center"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2" class="pl-3 pr-0 mr-0">
                        <div style="position: relative; display: flex; align-items: center;">
                          <v-text-field
                            v-model="skill.notes"
                            type="text"
                            hide-details
                            class="text-center"
                          ></v-text-field>
                          <div v-if="index === 0" style="position: absolute; top: -12px; right: 0;">In QN</div>
                            <v-checkbox
                            v-model="skill.inQN"
                            hide-details
                            class="ma-0 pa-0"
                          ></v-checkbox>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>

              <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                <div class="text-h6 mb-3">Global Modifiers</div>
                <v-row>
                  <v-col cols="1">
                    <v-text-field
                      v-model="characterData.skills.armorCheckPenalty"
                      label="ACP"
                      type="number"
                      hide-details
                      class="text-center"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="characterData.skills.globalModifiers"
                      label="Global Modifiers"
                      type="text"
                      hide-details
                      class="text-center"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="7">
                    <v-text-field
                      v-model="characterData.skills.skillsNotes"
                      label="Skills Notes"
                      type="text"
                      hide-details
                      class="text-center"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>

            </v-container>
          </v-tab-item>
          
          <v-tab-item>
            <!-- Feats and Special Abilities Tab -->
            <v-container>
              <h2 class="text-h4 mb-4">Feats and Special Abilities</h2>
              
              <!-- Sub-tabs for Feats, Special Abilities, and Spheres -->
              <v-tabs v-model="featSubTab" background-color="#8B4513" dark>
                <v-tab>Feats</v-tab>
                <v-tab>Special Abilities</v-tab>
                <v-tab>Spheres</v-tab>
              </v-tabs>
              
              <v-tabs-items v-model="featSubTab" style="background-color:transparent;">
                <!-- Feats Sub-tab -->
                <v-tab-item>
                  <v-row>
                    <v-col cols="12">
                      <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                        <div class="d-flex justify-space-between align-center mb-3">
                          <div class="text-h6">Feats</div>
                          <v-btn color="primary" @click="addFeatSection">
                            + Add Section
                          </v-btn>
                        </div>
                    
                    <!-- Feat Sections -->
                    <draggable
                      v-model="characterData.feats.sections"
                      group="feat-sections"
                      handle=".section-drag-handle"
                      class="mb-4"
                    >
                      <div v-for="(section, sectionIndex) in characterData.feats.sections" :key="`feat-section-${sectionIndex}`" class="mb-4">
                        <v-card outlined :style="`border-color: ${section.color}; border-width: 2px;`">
                          <v-card-title :style="`background-color: ${section.color}; color: white;`">
                            <div class="d-flex align-center mb-2">
                              <v-btn
                                v-if="deleteMode"
                                icon
                                x-small
                                color="error"
                                @click="deleteFeatSection(sectionIndex)"
                                class="mr-2"
                              >
                                <v-icon x-small>mdi-close</v-icon>
                              </v-btn>
                              <v-icon class="section-drag-handle mr-2" style="cursor: grab; color: white;">mdi-drag-horizontal</v-icon>
                              <v-text-field
                                v-model="section.name"
                                label="Section Name"
                                hide-details
                                class="mr-2"
                                style="max-width: 200px;"
                                dark
                              ></v-text-field>
                              <v-menu offset-y>
                                <template slot="activator" slot-scope="{ on, attrs }">
                                  <v-btn
                                    icon
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mr-2"
                                    :style="`background-color: ${section.color}; color: white;`"
                                  >
                                    <v-icon>mdi-palette</v-icon>
                                  </v-btn>
                                </template>
                                <v-color-picker
                                  v-model="section.color"
                                  flat
                                  hide-inputs
                                  show-swatches
                                ></v-color-picker>
                              </v-menu>
                              <v-btn
                                icon
                                small
                                color="white"
                                @click="addFeat(sectionIndex)"
                              >
                                <v-icon>mdi-plus</v-icon>
                              </v-btn>
                            </div>
                          </v-card-title>
                        
                        <v-card-text>
                          <!-- Feats in this section -->
                          <draggable
                            v-model="section.feats"
                            group="feats"
                            handle=".drag-handle"
                            class="elevation-1"
                            :style="`border-color: ${section.color};`"
                          >
                            <div
                              v-for="(feat, featIndex) in section.feats"
                              :key="`feat-${sectionIndex}-${featIndex}`"
                              class="d-flex align-center pa-2 border-bottom pt-4"
                              :style="`border-bottom: 1px solid ${section.color};`"
                            >
                              <v-btn
                                v-if="deleteMode"
                                icon
                                x-small
                                color="error"
                                @click="removeFeat(sectionIndex, featIndex)"
                                class="mr-2"
                              >
                                <v-icon x-small>mdi-close</v-icon>
                              </v-btn>
                              
                              <v-icon class="drag-handle mr-2" style="cursor: grab;">mdi-drag</v-icon>
                              
                              <v-text-field
                                v-model="feat.level"
                                type="number"
                                label="Lv"
                                hide-details
                                dense
                                class="mr-2"
                                style="max-width: 40px;"
                              ></v-text-field>
                              
                              <v-text-field
                                v-model="feat.name"
                                label="Name"
                                hide-details
                                dense
                                class="mr-2"
                                style="flex: 0.2;"
                              ></v-text-field>
                              
                              <v-text-field
                                v-model="feat.type"
                                label="Type"
                                hide-details
                                dense
                                class="mr-2"
                                style="max-width: 100px;"
                              ></v-text-field>
                              
                              <v-text-field
                                v-model="feat.shortDescription"
                                label="Short Description"
                                hide-details
                                dense
                                class="mr-2"
                                style="flex: 1;"
                              ></v-text-field>
                              
                              <v-btn
                                small
                                :style="`background-color: ${section.color}; color: white;`"
                                @click="openFeatDialog(feat)"
                                class="ml-auto"
                              >
                                Details
                              </v-btn>
                            </div>
                          </draggable>
                        </v-card-text>
                      </v-card>
                    </div>
                    </draggable>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-tab-item>
                
                <!-- Special Abilities Sub-tab -->
                <v-tab-item>
                  <v-row>
                    <v-col cols="12">
                      <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                        <div class="d-flex justify-space-between align-center mb-3">
                          <div class="text-h6">Special Abilities</div>
                          <v-btn color="primary" @click="addSpecialAbilitySection">
                            + Add Section
                          </v-btn>
                        </div>
                    
                    <!-- Special Ability Sections -->
                    <draggable
                      v-model="characterData.specialAbilities.sections"
                      group="special-ability-sections"
                      handle=".section-drag-handle"
                      class="mb-4"
                    >
                      <div v-for="(section, sectionIndex) in characterData.specialAbilities.sections" :key="`special-section-${sectionIndex}`" class="mb-4">
                        <v-card outlined :style="`border-color: ${section.color}; border-width: 2px;`">
                          <v-card-title :style="`background-color: ${section.color}; color: white;`">
                            <div class="d-flex align-center mb-2">
                              <v-btn
                                v-if="deleteMode"
                                icon
                                x-small
                                color="error"
                                @click="deleteSpecialAbilitySection(sectionIndex)"
                                class="mr-2"
                              >
                                <v-icon x-small>mdi-close</v-icon>
                              </v-btn>
                              <v-icon class="section-drag-handle mr-2" style="cursor: grab; color: white;">mdi-drag-horizontal</v-icon>
                              <v-text-field
                                v-model="section.name"
                                label="Section Name"
                                hide-details
                                class="mr-2"
                                style="max-width: 200px;"
                                dark
                              ></v-text-field>
                              <v-menu offset-y>
                                <template slot="activator" slot-scope="{ on, attrs }">
                                  <v-btn
                                    icon
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mr-2"
                                    :style="`background-color: ${section.color}; color: white;`"
                                  >
                                    <v-icon>mdi-palette</v-icon>
                                  </v-btn>
                                </template>
                                <v-color-picker
                                  v-model="section.color"
                                  flat
                                  hide-inputs
                                  show-swatches
                                ></v-color-picker>
                              </v-menu>
                              <v-btn
                                icon
                                small
                                color="white"
                                @click="addSpecialAbility(sectionIndex)"
                              >
                                <v-icon>mdi-plus</v-icon>
                              </v-btn>
                            </div>
                          </v-card-title>
                        
                        <v-card-text>
                          <!-- Special Abilities in this section -->
                          <draggable
                            v-model="section.abilities"
                            group="special-abilities"
                            handle=".drag-handle"
                            class="elevation-1"
                            :style="`border-color: ${section.color};`"
                          >
                            <div
                              v-for="(ability, abilityIndex) in section.abilities"
                              :key="`special-ability-${sectionIndex}-${abilityIndex}`"
                              class="d-flex align-center pa-2 border-bottom pt-4"
                              :style="`border-bottom: 1px solid ${section.color};`"
                            >
                              <v-btn
                                v-if="deleteMode"
                                icon
                                x-small
                                color="error"
                                @click="deleteSpecialAbility(sectionIndex, ability)"
                                class="mr-2"
                              >
                                <v-icon x-small>mdi-close</v-icon>
                              </v-btn>
                              
                              <v-icon class="drag-handle mr-2" style="cursor: grab;">mdi-drag</v-icon>
                              
                              <v-text-field
                                v-model="ability.level"
                                type="number"
                                label="Lv"
                                hide-details
                                dense
                                class="mr-2"
                                style="max-width: 40px;"
                              ></v-text-field>
                              
                              <v-text-field
                                v-model="ability.name"
                                label="Name"
                                hide-details
                                dense
                                class="mr-2"
                                style="flex: 0.8;"
                              ></v-text-field>
                              
                              <v-text-field
                                v-model="ability.type"
                                label="Type"
                                hide-details
                                dense
                                class="mr-2"
                                style="flex: 0.3;"
                              ></v-text-field>
                              
                              <v-text-field
                                v-model="ability.subsection"
                                label="Subsection"
                                hide-details
                                dense
                                class="mr-2"
                                style="flex: 0.5;"
                              ></v-text-field>
                              
                              <v-text-field
                                v-model="ability.shortDescription"
                                label="Short Description"
                                hide-details
                                dense
                                class="mr-2"
                                style="flex: 5;"
                              ></v-text-field>
                              
                              <v-btn
                                small
                                :style="`background-color: ${section.color}; color: white;`"
                                @click="openSpecialAbilityDetails(ability)"
                              >
                                Details
                              </v-btn>
                            </div>
                          </draggable>
                        </v-card-text>
                      </v-card>
                    </div>
                    </draggable>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-tab-item>
                
                <!-- Spheres Sub-tab -->
                <v-tab-item>
                  <v-row>
                    <v-col cols="12">
                      <v-card outlined class="pa-3 mb-4" style="background-color:#FFECC9;">
                        <div class="d-flex justify-space-between align-center mb-3">
                          <div class="text-h6">Spheres</div>
                          <v-btn color="primary" @click="addSphereSection">
                            + Add Section
                          </v-btn>
                        </div>
                    
                    <!-- Sphere Sections -->
                    <draggable
                      v-model="characterData.spheres.sections"
                      group="sphere-sections"
                      handle=".section-drag-handle"
                      class="mb-4"
                    >
                      <div v-for="(section, sectionIndex) in characterData.spheres.sections" :key="`sphere-section-${sectionIndex}`" class="mb-4">
                        <v-card outlined :style="`border-color: ${section.color}; border-width: 2px;`">
                          <v-card-title :style="`background-color: ${section.color}; color: white;`">
                            <div class="d-flex align-center mb-2">
                              <v-btn
                                v-if="deleteMode"
                                icon
                                x-small
                                color="error"
                                @click="deleteSphereSection(sectionIndex)"
                                class="mr-2"
                              >
                                <v-icon x-small>mdi-close</v-icon>
                              </v-btn>
                              <v-icon class="section-drag-handle mr-2" style="cursor: grab; color: white;">mdi-drag-horizontal</v-icon>
                              <v-text-field
                                v-model="section.name"
                                label="Section Name"
                                hide-details
                                class="mr-2"
                                style="max-width: 200px;"
                                dark
                              ></v-text-field>
                              <v-menu offset-y>
                                <template slot="activator" slot-scope="{ on, attrs }">
                                  <v-btn
                                    icon
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mr-2"
                                    :style="`background-color: ${section.color}; color: white;`"
                                  >
                                    <v-icon>mdi-palette</v-icon>
                                  </v-btn>
                                </template>
                                <v-color-picker
                                  v-model="section.color"
                                  flat
                                  hide-inputs
                                  show-swatches
                                ></v-color-picker>
                              </v-menu>
                              <v-btn
                                icon
                                small
                                color="white"
                                @click="addSphere(sectionIndex)"
                              >
                                <v-icon>mdi-plus</v-icon>
                              </v-btn>
                            </div>
                          </v-card-title>
                        
                        <v-card-text>
                          <!-- Spheres in this section -->
                          <draggable
                            v-model="section.spheres"
                            group="spheres"
                            handle=".drag-handle"
                            class="elevation-1"
                            :style="`border-color: ${section.color};`"
                          >
                            <div
                              v-for="(sphere, sphereIndex) in section.spheres"
                              :key="`sphere-${sectionIndex}-${sphereIndex}`"
                              class="d-flex align-center pa-2 border-bottom pt-4"
                              :style="`border-bottom: 1px solid ${section.color};`"
                            >
                              <v-btn
                                v-if="deleteMode"
                                icon
                                x-small
                                color="error"
                                @click="deleteSphere(sectionIndex, sphere)"
                                class="mr-2"
                              >
                                <v-icon x-small>mdi-close</v-icon>
                              </v-btn>
                              
                              <v-icon class="drag-handle mr-2" style="cursor: grab;">mdi-drag</v-icon>
                              
                              <v-text-field
                                v-model="sphere.level"
                                type="number"
                                label="Lv"
                                hide-details
                                dense
                                class="mr-2"
                                style="max-width: 40px;"
                              ></v-text-field>
                              
                              <v-text-field
                                v-model="sphere.name"
                                label="Name"
                                hide-details
                                dense
                                class="mr-2"
                                style="flex: 0.8;"
                              ></v-text-field>
                              
                              <v-text-field
                                v-model="sphere.type"
                                label="Type"
                                hide-details
                                dense
                                class="mr-2"
                                style="flex: 0.3;"
                              ></v-text-field>
                                                           
                              <v-text-field
                                v-model="sphere.shortDescription"
                                label="Short Description"
                                hide-details
                                dense
                                class="mr-2"
                                style="flex: 5;"
                              ></v-text-field>
                              
                              <v-btn
                                small
                                :style="`background-color: ${section.color}; color: white;`"
                                @click="openSphereDetails(sphere)"
                              >
                                Details
                              </v-btn>
                            </div>
                          </draggable>
                        </v-card-text>
                      </v-card>
                    </div>
                    </draggable>
                    
                        <!-- Delete Mode Button -->
                        
                      </v-card>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <div class="text-center mt-4">
                          <v-btn
                            :color="deleteMode ? 'success' : 'error'"
                            @click="toggleDeleteMode"
                          >
                            {{ deleteMode ? 'Save' : 'Delete Mode' }}
                          </v-btn>
                        </div>
              </v-tabs-items>
            </v-container>
          </v-tab-item>
          
          <v-tab-item eager>
            <!-- Equipment and Money Tab -->
            <equipment ref="equipment" :character="character"></equipment>
          </v-tab-item>

          <v-tab-item>
            <!-- Equipment and Money Tab -->
                          <v-container>
                <h2 class="text-h4 mb-4">Character Details</h2>
                

                
                <!-- Basic Character Info Fields -->
                <v-row style="margin-top: 24px;">
                  <v-col :cols="detail.cols" v-for="detail in [
                    {label: 'Class', value: 'className', cols: 12},
                    {label: 'Race', value: 'race', cols: 3},
                    {label: 'Gender', value: 'gender', cols: 3},
                    {label: 'Alignment', value: 'alignment', cols: 3},
                    {label: 'Deity', value: 'deity', cols: 3},
                    {label: 'Age', value: 'age', cols: 2},
                    {label: 'Height', value: 'height', cols: 2},
                    {label: 'Weight', value: 'weight', cols: 2},
                    {label: 'Hair', value: 'hair', cols: 2},
                    {label: 'Eyes', value: 'eyes', cols: 2},
                    {label: 'Homeland', value: 'homeland', cols: 2},
                    {label: 'Languages', value: 'languages', cols: 12},
                  ]" :key="detail.label">
                    <v-text-field v-model="characterData.characterDetails[detail.value]" :label="detail.label" hide-details style="width:100%; background-color:antiquewhite; padding-left:6px; padding-bottom:6px"></v-text-field>
                  </v-col>
                </v-row>
                
                <!-- Notes Section -->
                <v-row style="margin-top: 24px;">
                  <v-col cols="12">
                    <div class="text-subtitle-2 mb-2">Character Notes</div>
                    <textarea 
                      class="rich-text-editor-textarea"
                      v-model="characterData.notes"
                      placeholder="Enter your character notes here..."
                      rows="12"
                    ></textarea>
                  </v-col>
                </v-row>
            </v-container>
          </v-tab-item>
          
          <!-- Add more tab items as needed -->
        </v-tabs-items>
        
        <v-alert
          v-if="saveStatus"
          :type="saveStatus.type"
          :value="saveStatus.show"
          dismissible
          @input="saveStatus.show = false"
        >
          {{ saveStatus.message }}
        </v-alert>
      </v-card-text>
    </v-card>

    <!-- Feat Details Modal -->
    <v-dialog v-model="showFeatDialog" max-width="600px">
      <v-card>
        <v-card-title>
          {{ selectedFeat ? selectedFeat.name : 'Feat Details' }}
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="selectedFeatDescription"
            label="Long Description"
            rows="10"
            auto-grow
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="showFeatDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Special Ability Details Modal -->
    <v-dialog v-model="showSpecialAbilityDialog" max-width="600px">
      <v-card>
        <v-card-title>
          {{ selectedSpecialAbility ? selectedSpecialAbility.name : 'Special Ability Details' }}
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="selectedSpecialAbilityDescription"
            label="Long Description"
            rows="10"
            auto-grow
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="showSpecialAbilityDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Sphere Details Modal -->
    <v-dialog v-model="showSphereDialog" max-width="600px">
      <v-card>
        <v-card-title>
          {{ selectedSphere ? selectedSphere.name : 'Sphere Details' }}
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="selectedSphereDescription"
            label="Long Description"
            rows="10"
            auto-grow
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="showSphereDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dice Settings Dialog -->
    <attack-roller-settings-dialog 
      v-model="diceSettingsDialog" 
      :character="character"
    ></attack-roller-settings-dialog>
  </v-container>
</template>

<script>
import utilities from './utilities.js';
import buffUtilities from './buffUtilities.js';
import draggable from 'vuedraggable';
import equipment from './equipment.vue';
import AttackRollerSettingsDialog from './attackRollerSettingsDialog.vue';

export default {
  components: {
    draggable,
    equipment,
    AttackRollerSettingsDialog,
  },
  props: {
    character: {
      type: Object,
      required: true
    },
    locked: {
      type: Boolean,
      required: false,
      default: false,
    },
    applyingServerState: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      utilities,
      tab: 0,
      tabs: [
        { id: 'abilities', name: 'Ability Scores' },
        { id: 'defense', name: 'Defense' },
        { id: 'offense', name: 'Offense' },
        { id: 'skills', name: 'Skills' },
        { id: 'feats', name: 'Feats and Special Abilities' },
        { id: 'equipment', name: 'Equipment and Money' },
        { id: 'notes', name: 'Notes' }
      ],
      saveStatus: null,
      deleteMode: false,
      featHeaders: [
        { text: 'Lv', value: 'level', width: '50px' },
        { text: 'Name', value: 'name', width: '150px' },
        { text: 'Type', value: 'type', width: '75px' },
        { text: 'Short Description', value: 'shortDescription', },
        { text: 'Actions', value: 'actions', width: '100px' }
      ],
      selectedFeat: null,
      selectedSpecialAbility: null,
      selectedSphere: null,
      showFeatDialog: false,
      showSpecialAbilityDialog: false,
      showSphereDialog: false,
      featSubTab: 0,
      diceSettingsDialog: false,
      // Keyboard state tracking for character sheet tab navigation
      tabKeyPressed: false,
      // Ability-mod total last applied to stored attack strings. Re-baselined
      // on character load/save so autosave object replacement cannot skip
      // the next real buff toggle.
      attackSyncDataRef: this.character.characterData,
      lastSyncedAttackAbilityMod: null,
    };
  },
  mounted() {
    // Add keyboard shortcuts for character sheet tab navigation
    window.addEventListener('keydown', this.handleKeyboardShortcuts);
    window.addEventListener('keyup', this.handleKeyboardShortcuts);
  },
  
  beforeDestroy() {
    // Remove keyboard event listeners
    window.removeEventListener('keydown', this.handleKeyboardShortcuts);
    window.removeEventListener('keyup', this.handleKeyboardShortcuts);
  },
  computed: {
    characterData() {
      return this.character.characterData;
    },

    buffPointTrackers() {
      return this.character?.stickyWindows?.pointTrackers || [];
    },

    // Resolved active buff deltas (see buffUtilities.js for stacking rules)
    acBuffByType() {
      return buffUtilities.getAcBuffByType(this.characterData, this.buffPointTrackers);
    },

    acBuffTotal() {
      return Object.values(this.acBuffByType).reduce((sum, n) => sum + n, 0);
    },

    hpBuffTotal() {
      return buffUtilities.getHpBuffTotal(this.characterData, this.buffPointTrackers);
    },

    // Watch this resolved value directly so ability-score buffs update every
    // stored attack set after modifiedModifier has been recalculated.
    totalAttackAbilityModifier() {
      return this.getTotalAttackAbilityModifier();
    },

    drBuffSuffix() {
      const delta = buffUtilities.getDrBuffTotal(this.characterData, this.buffPointTrackers);
      return delta ? `${buffUtilities.formatModifier(delta)} (buffs)` : '';
    },

    // Effective HP presents base + buff; edits write back to the unbuffed base.
    effectiveHpMax: {
      get() {
        return (parseInt(this.characterData.defense.hp.max) || 0) + this.hpBuffTotal;
      },
      set(val) {
        this.characterData.defense.hp.max = (parseInt(val) || 0) - this.hpBuffTotal;
      }
    },

    effectiveHpCurrent: {
      get() {
        return (parseInt(this.characterData.defense.hp.current) || 0) + this.hpBuffTotal;
      },
      set(val) {
        this.characterData.defense.hp.current = (parseInt(val) || 0) - this.hpBuffTotal;
      }
    },
    adventuringRanks() {
      return this.characterData.skills.adventuring.reduce((sum, skill) => sum + parseInt(skill.ranks), 0);
    },
    backgroundRanks() {
      return this.characterData.skills.background.reduce((sum, skill) => sum + parseInt(skill.ranks), 0);
    },
    selectedFeatDescription: {
      get() {
        return this.selectedFeat ? this.selectedFeat.longDescription : '';
      },
      set(value) {
        if (this.selectedFeat) {
          this.selectedFeat.longDescription = value;
        }
      }
    },
    selectedSpecialAbilityDescription: {
      get() {
        return this.selectedSpecialAbility ? this.selectedSpecialAbility.longDescription : '';
      },
      set(value) {
        if (this.selectedSpecialAbility) {
          this.selectedSpecialAbility.longDescription = value;
        }
      }
    },
    
    selectedSphereDescription: {
      get() {
        return this.selectedSphere ? this.selectedSphere.longDescription : '';
      },
      set(value) {
        if (this.selectedSphere) {
          this.selectedSphere.longDescription = value;
        }
      }
    },

    // Computed property for damage bonus dropdown options
    damageBonusOptions() {
      return this.characterData.offense.damageBonuses.map((damageBonus, index) => {
        const damageText = this.getTotalDamageBonus(index);
        const name = damageBonus.name || `Damage Bonus ${index + 1}`;
        return {
          text: `${name} (${damageText})`,
          value: name
        };
      });
    },
    
    // Computed properties for AC calculations
    acTotal() {
      const ac = this.characterData.defense.ac;
      let total = 10; // Base 10
      
      // Add armor bonus
      if (ac.armorBonus) total += parseInt(ac.armorBonus);
      
      // Add shield bonus
      if (ac.shieldBonus) total += parseInt(ac.shieldBonus);
      
      // Add ability modifiers based on statModifiers configuration
      total += this.getTotalACModifier();
      total += this.getSpecialACModifier();
      
      // Add size modifier
      if (ac.sizeModifier) total += parseInt(ac.sizeModifier);
      
      // Add natural armor
      if (ac.naturalArmor) total += parseInt(ac.naturalArmor);
      
      // Add deflection
      if (ac.deflection) total += parseInt(ac.deflection);

      if (ac.miscModifier) total += parseInt(ac.miscModifier);
      if (ac.tempModifier) total += parseInt(ac.tempModifier);
      if(ac.enhancedNaturalArmor) total += parseInt(ac.enhancedNaturalArmor);
      if(ac.moraleBonus) total += parseInt(ac.moraleBonus);
      if(ac.profaneBonus) total += parseInt(ac.profaneBonus);
      if(ac.sacredBonus) total += parseInt(ac.sacredBonus);
      if(ac.dodgeBonus) total += parseInt(ac.dodgeBonus);
      if(ac.insightBonus) total += parseInt(ac.insightBonus);
      if(ac.untypedBonus) total += parseInt(ac.untypedBonus);
      if(ac.otherModifiers) total += this.updateDefenseFromModifiers();

      // Add resolved active buffs
      total += this.acBuffTotal;

      return total;
    },
    
    acTouch() {
      const ac = this.characterData.defense.ac;
      return this.acTotal - (ac.armorBonus || 0) - (ac.shieldBonus || 0) - (ac.naturalArmor || 0) - (ac.enhancedNaturalArmor || 0)
        - buffUtilities.getNonTouchAcBuffTotal(this.characterData, this.buffPointTrackers);
    },
    
    acFlatFooted() {
      const ac = this.characterData.defense.ac;
      return this.acTotal - this.getTotalACModifier() - (ac.dodgeBonus || 0) - (this.acBuffByType.dodge || 0);
    },
    
    // Computed properties for save calculations
    saveTotals() {
      const saves = {};
      Object.keys(this.characterData.defense.saves).forEach(key => {
        const save = this.characterData.defense.saves[key];
        let total = 0;
        
        if (save.baseSave) total += parseInt(save.baseSave);
        if (save.abilityModifiers) {
          for (const ability in save.abilityModifiers) {
            total += this.getScaledAbilityModifier(save.abilityModifiers, ability);
          }
        }
        if (save.magicModifier) total += parseInt(save.magicModifier);
        if (save.miscModifier) total += parseInt(save.miscModifier);
        if (save.tempModifier) total += parseInt(save.tempModifier);

        // Add resolved active buffs
        total += buffUtilities.getSaveBuffTotal(this.characterData, key, this.buffPointTrackers);

        saves[key] = total;
      });
      return saves;
    },    
    // Computed property for CMD calculation
    cmdTotal() {
      const cmd = this.characterData.defense.cmd;
      let total = 10; // Base 10
      
      // Parse BAB (could be "8/3" format) - take first number
      if (this.characterData.offense.bab) {
        const babValue = this.characterData.offense.bab.split('/')[0]; // Take first number if format is "8/3"
        total += parseInt(babValue) || 0;
      }
      
      // Add ability modifiers, limited by the shared Max Dex cap.
      total += this.getCappedAbilityModifierTotal(cmd.statModifiers);
      
      // Add size modifier
      if (cmd.sizeModifier) total += parseInt(cmd.sizeModifier);
      
      // Add misc and temp modifiers (parse numbers from text like AC does)
      if (cmd.miscModifiers) {
        const numbers = cmd.miscModifiers.match(/[+-]?\d+/g) || [];
        const miscTotal = numbers.reduce((sum, num) => sum + parseInt(num), 0);
        total += miscTotal;
      }
      
      if (cmd.tempModifiers) {
        const numbers = cmd.tempModifiers.match(/[+-]?\d+/g) || [];
        const tempTotal = numbers.reduce((sum, num) => sum + parseInt(num), 0);
        total += tempTotal;
      }
      
      // Add relevant AC bonuses (excluding shield, armor, natural, enhanced natural)
      const ac = this.characterData.defense.ac;
      if (ac.deflection) total += parseInt(ac.deflection);
      if (ac.dodgeBonus) total += parseInt(ac.dodgeBonus);
      if (ac.insightBonus) total += parseInt(ac.insightBonus);
      if (ac.moraleBonus) total += parseInt(ac.moraleBonus);
      if (ac.profaneBonus) total += parseInt(ac.profaneBonus);
      if (ac.sacredBonus) total += parseInt(ac.sacredBonus);
      if (ac.untypedBonus) total += parseInt(ac.untypedBonus);
      if (ac.miscModifier) total += parseInt(ac.miscModifier);
      
      // Parse other AC modifiers like the quick details does
      if (ac.otherModifiers) {
        const numbers = ac.otherModifiers.match(/[+-]?\d+/g) || [];
        const otherTotal = numbers.reduce((sum, num) => sum + parseInt(num), 0);
        total += otherTotal;
      }

      // Add resolved active buffs (CMD-targeted plus applicable AC-targeted)
      total += buffUtilities.getCmdBuffTotal(this.characterData, this.buffPointTrackers);

      return total;
    },



    // Computed property for CMB calculation
    cmbTotal() {
      const cmb = this.characterData.offense.cmb;
      let total = 0;
      
      // Parse BAB (could be "8/3" format)
      if (cmb.baseAttackBonus) {
        const babValue = cmb.baseAttackBonus.split('/')[0]; // Take first number if format is "8/3"
        total += parseInt(babValue) || 0;
      }
      
      if (cmb.strModifier) total += parseInt(cmb.strModifier);
      if (cmb.sizeModifier) total += parseInt(cmb.sizeModifier);
      if (cmb.miscModifiers) total += parseInt(cmb.miscModifiers);
      if (cmb.tempModifiers) total += parseInt(cmb.tempModifiers);
      
      return total;
    },
  },
  watch: {
    'characterData.offense.bab': {
      handler(newVal) {
        this.characterData.offense.cmb.baseAttackBonus = newVal;
        // CMB will update automatically via computed property
      },
      immediate: true
    },
    // Recalculate stored ability-derived values whenever buffs change
    // (toggled, edited, or replaced by a character load).
    'characterData.buffs': {
      handler() {
        this.updateAllModifiedScores();
      },
      deep: true,
      immediate: true
    },
    // Common statuses (e.g. Fatigued) can also modify ability scores.
    'characterData.commonStatuses': {
      handler() {
        this.updateAllModifiedScores();
      },
      deep: true,
      immediate: true
    },
    // Point-tracker formulas can feed ability-score buffs, which then affect
    // every other ability-derived total.
    buffPointTrackers: {
      handler() {
        this.updateAllModifiedScores();
      },
      deep: true,
      immediate: true
    },
    // Autosave/autoload replaces characterData with a clone. Re-baseline so
    // the next buff toggle is applied instead of being treated as a load.
    characterData: {
      immediate: true,
      handler(newData) {
        this.baselineAttackAbilitySync(newData);
      },
    },
    applyingServerState(isApplying) {
      if (!isApplying) this.baselineAttackAbilitySync(this.characterData);
    },
    totalAttackAbilityModifier(newValue) {
      this.syncAttackSetsToAbilityModifier(newValue);
    },
  },
  methods: {
    resetDay() {
      this.$refs.equipment?.resetDay?.()
    },
    // Accept both legacy boolean entries and the new
    // { modifies, multiplier } entries. This keeps old saves working without
    // requiring a destructive migration.
    isAbilityModifierEnabled(config) {
      return config && typeof config === 'object' ? !!config.modifies : !!config;
    },

    getAbilityModifierMultiplier(config) {
      if (!config || typeof config !== 'object') return 1;
      const multiplier = parseFloat(config.multiplier);
      return isNaN(multiplier) ? 1 : multiplier;
    },

    setAbilityModifierEnabled(modifierMap, ability, enabled) {
      const current = modifierMap[ability];
      this.$set(modifierMap, ability, {
        modifies: !!enabled,
        multiplier: this.getAbilityModifierMultiplier(current),
      });
    },

    setAbilityModifierMultiplier(modifierMap, ability, multiplier) {
      const current = modifierMap[ability];
      const parsedMultiplier = parseFloat(multiplier);
      this.$set(modifierMap, ability, {
        modifies: this.isAbilityModifierEnabled(current),
        multiplier: isNaN(parsedMultiplier) ? 1 : parsedMultiplier,
      });
    },

    getScaledAbilityModifier(modifierMap, ability) {
      if (!modifierMap || !this.isAbilityModifierEnabled(modifierMap[ability])) return 0;
      const modifier = this.characterData.abilities[ability]?.modifiedModifier || 0;
      return Math.floor(modifier * this.getAbilityModifierMultiplier(modifierMap[ability]));
    },

    getAbilityScoreBreakdown(key) {
      const ability = this.characterData.abilities[key];
      if (!ability) return [];

      const number = value => parseInt(value) || 0;
      const lines = [`${number(ability.score)} base`];

      if (number(ability.bonus)) {
        lines.push(`${buffUtilities.formatModifier(number(ability.bonus))} bonus`);
      }

      const buffBreakdown = buffUtilities.getAbilityBuffBreakdown(
        this.characterData,
        key,
        this.getBaseAbilityModifiers(),
        this.buffPointTrackers
      );
      Object.entries(buffBreakdown.byType).forEach(([type, amount]) => {
        if (!amount) return;
        const typeInfo = buffUtilities.BONUS_TYPE_MAP[type];
        const label = typeInfo ? typeInfo.text.toLowerCase() : type;
        lines.push(`${buffUtilities.formatModifier(amount)} ${label}`);
      });

      [
        ['damage', 'damage'],
        ['drain', 'drain'],
        ['burn', 'burn'],
        ['wither', 'wither'],
        ['permanent', 'permanent'],
      ].forEach(([field, label]) => {
        const amount = number(ability[field]);
        if (amount) lines.push(`-${amount} ${label}`);
      });

      return lines;
    },

    getAbilityName(key) {
      const names = {
        strength: 'Strength',
        dexterity: 'Dexterity',
        constitution: 'Constitution',
        intelligence: 'Intelligence',
        wisdom: 'Wisdom',
        charisma: 'Charisma'
      };
      return names[key] || key;
    },
    
    openDiceSettings() {
      if (this.character && this.character.characterData && this.character.characterData.offense && this.character.characterData.offense.diceSettings) {
        this.diceSettingsDialog = true;
      }
    },
    
    getTotalDiceSettingsCount() {
      if (!this.character?.characterData?.offense?.diceSettings) return 0;
      const settings = this.character.characterData.offense.diceSettings;
      let count = 0;
      if (settings.rerollAttacks?.enabled) count++;
      if (settings.rerollConfirmations?.enabled) count++;
      if (settings.missChance?.enabled) count++;
      if (settings.fortification?.enabled) count++;
      if (settings.ignorePrecision?.enabled) count++;
      return count;
    },
    
    combineDamageText(baseDamage, tempModifiers) {
      // Parse base damage
      const baseParsed = this.parseDamageText(baseDamage);
      
      // Parse temp modifiers
      const tempParsed = this.parseDamageText(tempModifiers);
      
      // Combine dice
      let combinedDice = [...baseParsed.dice, ...tempParsed.dice];
      
      // Combine numeric modifiers
      let combinedModifier = baseParsed.modifier + tempParsed.modifier;
      
      // Build result
      let result = '';
      if (combinedDice.length > 0) {
        result += combinedDice.join('+');
      }
      if (combinedModifier !== 0) {
        if (result) {
          result += (combinedModifier >= 0 ? '+' : '') + combinedModifier;
        } else {
          result = combinedModifier.toString();
        }
      }
      
      return result || '0';
    },
    
    parseDamageText(damageText) {
      if (!damageText) return { dice: [], modifier: 0 };
      
      const dice = [];
      let modifier = 0;
      
      // Remove all spaces
      const cleanText = damageText.replace(/\s/g, '');
      
      // Split by + and - to get individual parts
      const parts = cleanText.split(/(?=[+-])/);
      
      parts.forEach(part => {
        if (!part) return;
        
        // Check if it's a dice expression
        if (part.includes('d')) {
          // Remove leading + if present to avoid double plus signs
          const cleanDice = part.startsWith('+') ? part.substring(1) : part;
          dice.push(cleanDice);
        } else {
          // It's a numeric modifier
          const num = parseInt(part) || 0;
          modifier += num;
        }
      });
      
      return { dice, modifier };
    },
    
      combineAttackText(baseAttack, tempModifiers) {
        console.log(baseAttack, tempModifiers)
        // Split attack bonuses by / (e.g., "+10/+5/+0")
        const baseAttacks = baseAttack.split('/');
        
        // Parse temp modifiers to get total numeric modifier
        const tempParsed = this.parseDamageText(tempModifiers);
        const tempModifier = tempParsed.modifier;
        
        // Parse global attack modifier
        const globalParsed = this.parseDamageText(this.character.characterData.offense.globalAttackModifier);
        const globalModifier = globalParsed.modifier;
        
        // Apply temp, global, and active buff modifiers to each attack bonus
        const totalModifier = tempModifier
          + globalModifier
          + buffUtilities.getAttackBuffTotal(this.characterData, this.buffPointTrackers);
        const modifiedAttacks = baseAttacks.map(attack => {
          const baseModifier = parseInt(attack) || 0;
          const newModifier = baseModifier + totalModifier;
          return (newModifier >= 0 ? '+' : '') + newModifier;
        });
        
        return modifiedAttacks.join('/');
      },
    
    getSaveName(key) {
      const names = {
        fortitude: 'Fortitude',
        reflex: 'Reflex',
        will: 'Will'
      };
      return names[key] || key;
    },

    getTotalSaveAbilityModifier(key) {
      const save = this.characterData.defense.saves[key];
      let total = 0;
      if (save.abilityModifiers) {
        for (const ability in save.abilityModifiers) {
          total += this.getScaledAbilityModifier(save.abilityModifiers, ability);
        }
      }
      return total;
    },
    
    updateAbilityModifier(key) {
      const ability = this.characterData.abilities[key];
      ability.modifier = Math.floor((ability.score - 10) / 2);
      
      // Update modified scores (all of them, since buff amounts like
      // "[Str/0.5]" can make one ability depend on another)
      this.updateAllModifiedScores();
    },
    
    getBaseModifiedScore(key) {
      const ability = this.characterData.abilities[key];
      let modifiedScore = parseInt(ability.score);
      if (ability.bonus) modifiedScore += parseInt(ability.bonus);
      if (ability.damage) modifiedScore -= parseInt(ability.damage);
      if (ability.drain) modifiedScore -= parseInt(ability.drain);
      if (ability.burn) modifiedScore -= parseInt(ability.burn);
      if (ability.wither) modifiedScore -= parseInt(ability.wither);
      if (ability.permanent) modifiedScore -= parseInt(ability.permanent);
      return modifiedScore;
    },

    // Unbuffed ability modifiers, used to evaluate "[Str/0.5]" style buff
    // amounts on ability scores without self-referencing feedback loops.
    getBaseAbilityModifiers() {
      const modifiers = {};
      Object.keys(this.characterData.abilities).forEach(key => {
        modifiers[key] = Math.floor((this.getBaseModifiedScore(key) - 10) / 2);
      });
      return modifiers;
    },

    updateModifiedScore(key) {
      const ability = this.characterData.abilities[key];
      ['bonus', 'damage', 'drain', 'burn', 'wither', 'permanent'].forEach(field => {
        if (ability[field] && ability[field] < 0) ability[field] = 0;
      });

      let modifiedScore = this.getBaseModifiedScore(key);

      // Add resolved active buffs targeting this ability score
      modifiedScore += buffUtilities.getAbilityBuffTotal(
        this.characterData,
        key,
        this.getBaseAbilityModifiers(),
        this.buffPointTrackers
      );

      ability.modifiedScore = modifiedScore;
      ability.modifiedModifier = Math.floor((modifiedScore - 10) / 2);
    },

    updateAllModifiedScores() {
      Object.keys(this.characterData.abilities).forEach(key => this.updateModifiedScore(key));
    },
    
    updateDefenseFromModifiers(){
        const text = this.characterData.defense.ac.otherModifiers;
        const numbers = text.match(/[+-]?\d+/g) || [];
        const total = numbers.reduce((sum, num) => sum + parseInt(num), 0);
        return total;
    },

    getTotalACModifier() {
      return this.getCappedAbilityModifierTotal(this.characterData.defense.ac.statModifiers);
    },

    getCappedAbilityModifierTotal(modifierMap) {
      let total = 0;
      if (modifierMap) {
        for (const ability in modifierMap) {
          total += this.getScaledAbilityModifier(modifierMap, ability);
        }
      }

      const rawMaxDex = this.characterData.defense.ac.maxDex;
      if (rawMaxDex === '' || rawMaxDex === null || rawMaxDex === undefined) return total;

      const maxDex = Number(rawMaxDex);
      return Number.isFinite(maxDex) ? Math.min(total, maxDex) : total;
    },

    getSpecialACModifier() {
      let total = 0;
      if (this.characterData.defense.ac.specialAbilityModifiers) {
        for (const ability in this.characterData.defense.ac.specialAbilityModifiers) {
          total += this.getScaledAbilityModifier(this.characterData.defense.ac.specialAbilityModifiers, ability);
        }
      }
      return total;
    },

    getTotalCMDStrModifier() {
      return this.getCappedAbilityModifierTotal(this.characterData.defense.cmd.statModifiers);
    },

    getTotalAttackAbilityModifier() {
      let total = 0;
      if (this.characterData.offense.attackBonus && this.characterData.offense.attackBonus.abilityModifiers) {
        for (const ability in this.characterData.offense.attackBonus.abilityModifiers) {
          total += this.getScaledAbilityModifier(this.characterData.offense.attackBonus.abilityModifiers, ability);
        }
      }
      return total;
    },

    

    // Shift every attack set's bonus string (e.g. "+10/+5") by delta,
    // mirroring a change in the general attack ability modifier.
    adjustAttackSetBonuses(delta) {
      (this.characterData.offense.attacks || []).forEach(attack => {
        const text = String(attack.attackBonus == null ? '' : attack.attackBonus).trim();
        if (!text) return;
        attack.attackBonus = text.split('/').map(part => {
          const value = parseInt(part);
          if (isNaN(value)) return part;
          const adjusted = value + delta;
          return (adjusted >= 0 ? '+' : '') + adjusted;
        }).join('/');
      });
    },

    baselineAttackAbilitySync(dataRef = this.characterData) {
      this.attackSyncDataRef = dataRef;
      this.lastSyncedAttackAbilityMod = this.getTotalAttackAbilityModifier();
    },

    // Apply the general-attack ability-mod delta to every stored attack string.
    // Load/save clones re-baseline instead of applying, so autosave cannot
    // skip the next real buff toggle.
    syncAttackSetsToAbilityModifier(current) {
      if (
        this.applyingServerState
        || this.lastSyncedAttackAbilityMod === null
        || this.attackSyncDataRef !== this.characterData
      ) {
        this.baselineAttackAbilitySync(this.characterData);
        return;
      }
      const delta = current - this.lastSyncedAttackAbilityMod;
      this.lastSyncedAttackAbilityMod = current;
      if (delta) this.adjustAttackSetBonuses(delta);
    },

    getTotalAttackBonus() {
      let total = 0;
      
      // Add BAB (first number if in "8/3" format)
      if (this.characterData.offense.bab) {
        const babValue = this.characterData.offense.bab.split('/')[0]; // Take first number if format is "8/3"
        total += parseInt(babValue) || 0;
      }
      
      // Add ability modifiers
      total += this.getTotalAttackAbilityModifier();
      
      // Add all the bonus fields
      const attackBonus = this.characterData.offense.attackBonus;
      if (attackBonus) {
        if (attackBonus.enhancementBonus) total += parseInt(attackBonus.enhancementBonus);
        if (attackBonus.luckBonus) total += parseInt(attackBonus.luckBonus);
        if (attackBonus.moraleBonus) total += parseInt(attackBonus.moraleBonus);
        if (attackBonus.profaneBonus) total += parseInt(attackBonus.profaneBonus);
        if (attackBonus.sacredBonus) total += parseInt(attackBonus.sacredBonus);
        if (attackBonus.insightBonus) total += parseInt(attackBonus.insightBonus);
        if (attackBonus.untypedBonus) total += parseInt(attackBonus.untypedBonus);
        if (attackBonus.competenceBonus) total += parseInt(attackBonus.competenceBonus);
        if (attackBonus.sizeModifier) total += parseInt(attackBonus.sizeModifier);
        
        // Parse misc and temp modifiers (text fields)
        if (attackBonus.miscModifiers) {
          const numbers = attackBonus.miscModifiers.match(/[+-]?\d+/g) || [];
          const miscTotal = numbers.reduce((sum, num) => sum + parseInt(num), 0);
          total += miscTotal;
        }
        
        if (attackBonus.tempModifiers) {
          const numbers = attackBonus.tempModifiers.match(/[+-]?\d+/g) || [];
          const tempTotal = numbers.reduce((sum, num) => sum + parseInt(num), 0);
          total += tempTotal;
        }
      }

      // Add resolved active buffs
      total += buffUtilities.getAttackBuffTotal(this.characterData, this.buffPointTrackers);

      return total;
    },

    // Damage Bonus Methods
    getTotalDamageAbilityModifier(index) {
      const damageBonus = this.characterData.offense.damageBonuses[index];
      if (!damageBonus || !damageBonus.abilityModifiers) return 0;
      
      let total = 0;
      for (const ability of ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma']) {
        if (damageBonus.abilityModifiers[ability] && damageBonus.abilityModifiers[ability].modifies) {
          const modifier = this.characterData.abilities[ability].modifiedModifier;
          const multiplier = damageBonus.abilityModifiers[ability].multiplier || 1;
          total += Math.floor(modifier * multiplier);
        }
      }
      return total;
    },

    getSkillAbilityDisplayText(skill) {
      if (!skill || !skill.abilityModifiers) return this.getAbilityShortName(skill.ability);
      
      const activeAbilities = [];
      for (const ability of ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma']) {
        if (skill.abilityModifiers[ability] && skill.abilityModifiers[ability].modifies) {
          activeAbilities.push(this.getAbilityShortName(ability));
        }
      }
      
      return activeAbilities.length > 0 ? activeAbilities.join(', ') : this.getAbilityShortName(skill.ability);
    },

    getTotalDamageBonus(index, attack) {
      const damageBonus = this.characterData.offense.damageBonuses[index];
      if (!damageBonus) return "0";

      console.log("damageBonus", damageBonus)
      
      let modifierTotal = 0;
      
      // Add ability modifiers
      modifierTotal += this.getTotalDamageAbilityModifier(index);
      
      // Add all the bonus fields
      if (damageBonus.enhancementBonus) modifierTotal += parseInt(damageBonus.enhancementBonus) || 0;
      if (damageBonus.luckBonus) modifierTotal += parseInt(damageBonus.luckBonus) || 0;
      if (damageBonus.moraleBonus) modifierTotal += parseInt(damageBonus.moraleBonus) || 0;
      if (damageBonus.profaneBonus) modifierTotal += parseInt(damageBonus.profaneBonus) || 0;
      if (damageBonus.sacredBonus) modifierTotal += parseInt(damageBonus.sacredBonus) || 0;
      if (damageBonus.insightBonus) modifierTotal += parseInt(damageBonus.insightBonus) || 0;
      if (damageBonus.untypedBonus) modifierTotal += parseInt(damageBonus.untypedBonus) || 0;
      if (damageBonus.competenceBonus) modifierTotal += parseInt(damageBonus.competenceBonus) || 0;
      if (damageBonus.feat) modifierTotal += parseInt(damageBonus.feat) || 0;
      if (damageBonus.sizeModifier) modifierTotal += parseInt(damageBonus.sizeModifier) || 0;
      
      // Parse misc and temp modifiers (text fields)
      if (damageBonus.miscModifiers) {
        const numbers = damageBonus.miscModifiers.match(/[+-]?\d+/g) || [];
        const miscTotal = numbers.reduce((sum, num) => sum + parseInt(num), 0);
        modifierTotal += miscTotal;
      }
      
      if (damageBonus.tempModifiers) {
        const numbers = damageBonus.tempModifiers.match(/[+-]?\d+/g) || [];
        const tempTotal = numbers.reduce((sum, num) => sum + parseInt(num), 0);
        modifierTotal += tempTotal;
      }

      // Step only the configured base dice, then append buff-added dice.
      const buffDamage = buffUtilities.getDamageBuffParts(
        this.characterData,
        damageBonus,
        this.buffPointTrackers
      );
      modifierTotal += buffDamage.modifier;
      const dice = buffUtilities.stepBaseDamageDice(
        damageBonus.dice || "",
        buffUtilities.getDamageDiceStepTotal(this.characterData)
      );
      let total = buffUtilities.combineDamageExpressions(
        dice,
        { dice: buffDamage.dice, modifier: modifierTotal }
      );

      total = this.combineDamageText(total, this.character.characterData.offense.globalDamageModifier);

      if(attack && attack.tempDamageModifiers) {
        total = this.combineDamageText(total, attack.tempDamageModifiers);
      }
      
      return total;
    },

    getBuffedRawDamage(baseDamage, attack) {
      const steppedBase = buffUtilities.stepBaseDamageDice(
        baseDamage,
        buffUtilities.getDamageDiceStepTotal(this.characterData)
      );
      const buffDamage = buffUtilities.getDamageBuffParts(
        this.characterData,
        null,
        this.buffPointTrackers
      );
      let total = buffUtilities.combineDamageExpressions(
        steppedBase,
        { dice: buffDamage.dice, modifier: buffDamage.modifier }
      );
      total = this.combineDamageText(total, this.characterData.offense.globalDamageModifier);
      if (attack && attack.tempDamageModifiers) {
        total = this.combineDamageText(total, attack.tempDamageModifiers);
      }
      return total;
    },

    getDamageSectionText(baseDamage, target) {
      const buffDamage = buffUtilities.getDamageSectionBuffText(
        this.characterData,
        target,
        this.buffPointTrackers
      );
      if (buffDamage === '0') return baseDamage || '';
      return buffUtilities.combineDamageExpressions(baseDamage, buffDamage);
    },

    getCriticalConfirmationBonus() {
      const stored = this.characterData.offense.attackBonus.criticalConfirmBonus;
      const storedText = stored === null || stored === undefined ? '' : String(stored);
      const storedTotal = (storedText.match(/[+-]?\d+/g) || [])
        .reduce((sum, amount) => sum + parseInt(amount), 0);
      const buffTotal = buffUtilities.getCriticalConfirmationBuffTotal(
        this.characterData,
        this.buffPointTrackers
      );
      if (!storedText.trim() && !buffTotal) return '';
      return storedTotal + buffTotal;
    },

    getSelectedDamageText(damageBonusName) {
      if (!damageBonusName) return '';
      
      const damageBonus = this.characterData.offense.damageBonuses.find(db => db.name === damageBonusName);
      if (!damageBonus) return '';
      
      const index = this.characterData.offense.damageBonuses.indexOf(damageBonus);
      return this.getTotalDamageBonus(index);
    },

    addDamageBonus() {
      const newDamageBonus = {
        name: '',
        showInDetails: false,
        total: 0,
        abilityModifiers: {
          strength: {modifies: true, multiplier: 1},
          dexterity: {modifies: false, multiplier: 1},
          constitution: {modifies: false, multiplier: 1},
          intelligence: {modifies: false, multiplier: 1},
          wisdom: {modifies: false, multiplier: 1},
          charisma: {modifies: false, multiplier: 1}
        },
        dice: '',
        critRange: '',
        critMultiplier: '',
        type: '',
        enhancementBonus: 0,
        luckBonus: 0,
        moraleBonus: 0,
        profaneBonus: 0,
        sacredBonus: 0,
        insightBonus: 0,
        untypedBonus: 0,
        competenceBonus: 0,
        feat: 0,
        sizeModifier: 0,
        miscModifiers: '',
        tempModifiers: '',
        notes: ''
      };
      
      this.characterData.offense.damageBonuses.push(newDamageBonus);
    },

    removeDamageBonus(index) {
      if (this.characterData.offense.damageBonuses.length > 1) {
        this.characterData.offense.damageBonuses.splice(index, 1);
      }
    },

    copyDamageBonusToClipboard(damageBonus) {
      let newText = damageBonus.name + ": " + this.getTotalDamageBonus(damageBonus);
      navigator.clipboard.writeText(newText);
    },

    buildAttackRollCommand(attack) {
      let command = "";
      if(this.locked)
        command = "!gr {";
      else
        command = "!r {";
      
      // Attack bonus (combining with temp modifiers)
      let attackText = attack.combinedAttackBonus;
      if (!attackText || attackText === '0' && attack.tempAttackModifiers) {
        attackText = this.combineAttackText(attack.attackBonus, attack.tempAttackModifiers);
      }
      command += `atk:"${attackText}", `;
      
      // Damage from selected damage bonus configuration
      let damageText = '';
      if (attack.damageBonusName) {
        // Find the index of the selected damage bonus configuration
        const damageBonusIndex = this.character.characterData.offense.damageBonuses.findIndex(db => db.name === attack.damageBonusName);
        if (damageBonusIndex !== -1) {
          damageText = this.getTotalDamageBonus(damageBonusIndex, attack);
        }
      }
      
      // Fallback to raw damage if no damage bonus selected or calculation failed
      if (!damageText || damageText === '0') {
        damageText = this.getBuffedRawDamage(attack.damage || '', attack);
      }
            
      command += `damage:"${damageText}", `;
      
      // Critical range and multiplier
      command += `critRange:"${attack.criticalRange}", `;
      command += `critMult:"${attack.criticalMult}", `;
      
      // Critical confirm bonus (from general attack bonus, not individual attack)
      const critConfirmBonus = this.getCriticalConfirmationBonus();
      if (critConfirmBonus !== undefined && critConfirmBonus !== '') {
        command += `critConfirmBonus:"${critConfirmBonus}", `;
      }
      
      // Get damage bonus fields if a damage bonus is selected
      let damageBonus = null;
      if (attack.damageBonusName) {
        damageBonus = this.character.characterData.offense.damageBonuses.find(db => db.name === attack.damageBonusName);
      }
      const diceSettings = this.character?.characterData?.offense?.diceSettings;

      
      // Non-multiplied damage
      const nonMultipliedDamage = attack.buffEffectsResolved
        ? attack.nonMultipliedDamage
        : this.getDamageSectionText(
          damageBonus?.nonMultipliedDamage || attack.nonMultipliedDamage || '',
          'nonMultipliedDamage'
        );
      if (nonMultipliedDamage !== undefined && nonMultipliedDamage !== '') {
        command += `nonMultDamage:"${nonMultipliedDamage}", `;
      }
      
      // Precision damage
      const precision = attack.buffEffectsResolved
        ? attack.precision
        : this.getDamageSectionText(
          damageBonus?.precision || attack.precision || '',
          'precision'
        );
      if (!diceSettings?.ignorePrecision?.enabled && precision !== undefined && precision !== '') {
        command += `precision:"${precision}", `;
      }
      
      // Critical bonus damage
      const criticalBonusDamage = attack.buffEffectsResolved
        ? attack.criticalBonusDamage
        : this.getDamageSectionText(
          damageBonus?.bonusCriticalDamage || attack.criticalBonusDamage || '',
          'criticalDamage'
        );
      if (criticalBonusDamage !== undefined && criticalBonusDamage !== '') {
        command += `critBonusDamage:"${criticalBonusDamage}", `;
      }
      
      // Remove trailing comma and space
      command = command.replace(/, $/, '');
      command += "}";
      
      // Add dice settings if any are enabled
      if (diceSettings) {
        let settings = [];
        
        // Miss chance
        if (diceSettings.missChance?.enabled && diceSettings.missChance?.missChanceValue) {
          settings.push(`miss-chance: ${diceSettings.missChance.missChanceValue}`);
        }
        
        // Fortification
        if (diceSettings.fortification?.enabled && diceSettings.fortification?.fortificationValue) {
          settings.push(`fort: ${diceSettings.fortification.fortificationValue}`);
        }
        
        // Reroll attacks
        if (diceSettings.rerollAttacks?.enabled) {
          let rrAtk = diceSettings.rerollAttacks.attacksToReroll || 'a';
          if (diceSettings.rerollAttacks.rerollTimes) {
            rrAtk += `||${diceSettings.rerollAttacks.rerollTimes}`;
          }
          settings.push(`rrAtk:${rrAtk}`);
        }
        
        // Reroll confirmations
        if (diceSettings.rerollConfirmations?.enabled) {
          let rrConf = 'a';
          if (diceSettings.rerollConfirmations.rerollTimes) {
            rrConf += `||${diceSettings.rerollConfirmations.rerollTimes}`;
          }
          settings.push(`rrConf:${rrConf}`);
        }
        
        // Reroll miss chance
        if (diceSettings.missChance?.rerollMissChance?.enabled) {
          let rrMiss = diceSettings.missChance.rerollMissChance.attacksToReroll || 'a';
          if (diceSettings.missChance.rerollMissChance.rerollTimes) {
            rrMiss += `||${diceSettings.missChance.rerollMissChance.rerollTimes}`;
          }
          settings.push(`rrMiss:${rrMiss}`);
        }
        
        // Reroll fortification
        if (diceSettings.fortification?.rerollFortification?.enabled) {
          let rrFort = diceSettings.fortification.rerollFortification.attacksToReroll || 'a';
          if (diceSettings.fortification.rerollFortification.rerollTimes) {
            rrFort += `||${diceSettings.fortification.rerollFortification.rerollTimes}`;
          }
          settings.push(`rrFort:${rrFort}`);
        }
        
        // Add settings to command if any exist
        if (settings.length > 0) {
          command += `, {${settings.join(', ')}}`;
        }
      }
      
      return command;
    },

    copyAttackToClipboard(attack) {
      const command = this.buildAttackRollCommand(attack);
      navigator.clipboard.writeText(command);
    },

    getTotalCMBAbilityModifier() {
      let total = 0;
      if (this.characterData.offense.cmb && this.characterData.offense.cmb.abilityModifiers) {
        for (const ability in this.characterData.offense.cmb.abilityModifiers) {
          total += this.getScaledAbilityModifier(this.characterData.offense.cmb.abilityModifiers, ability);
        }
      }
      return total;
    },

    getTotalCMB2AbilityModifier() {
      let total = 0;
      if (this.characterData.offense.cmb2 && this.characterData.offense.cmb2.abilityModifiers) {
        for (const ability in this.characterData.offense.cmb2.abilityModifiers) {
          total += this.getScaledAbilityModifier(this.characterData.offense.cmb2.abilityModifiers, ability);
        }
      }
      return total;
    },

    getTotalCMB() {
      let total = 0;
      
      // Add BAB (first number if in "8/3" format)
      if (this.characterData.offense.bab) {
        const babValue = this.characterData.offense.bab.split('/')[0]; // Take first number if format is "8/3"
        total += parseInt(babValue) || 0;
      }
      
      // Add ability modifiers
      total += this.getTotalCMBAbilityModifier();
      
      // Add size modifier
      if (this.characterData.offense.cmb && this.characterData.offense.cmb.sizeModifier) {
        total += parseInt(this.characterData.offense.cmb.sizeModifier);
      }
      
      // Parse misc and temp modifiers (text fields)
      if (this.characterData.offense.cmb && this.characterData.offense.cmb.miscModifiers) {
        const numbers = this.characterData.offense.cmb.miscModifiers.match(/[+-]?\d+/g) || [];
        const miscTotal = numbers.reduce((sum, num) => sum + parseInt(num), 0);
        total += miscTotal;
      }
      
      if (this.characterData.offense.cmb && this.characterData.offense.cmb.tempModifiers) {
        const numbers = this.characterData.offense.cmb.tempModifiers.match(/[+-]?\d+/g) || [];
        const tempTotal = numbers.reduce((sum, num) => sum + parseInt(num), 0);
        total += tempTotal;
      }
      
      // Add attack bonus fields (excluding enhancement, size, and temp)
      const attackBonus = this.characterData.offense.attackBonus;
      if (attackBonus) {
        if (attackBonus.luckBonus) total += parseInt(attackBonus.luckBonus);
        if (attackBonus.moraleBonus) total += parseInt(attackBonus.moraleBonus);
        if (attackBonus.profaneBonus) total += parseInt(attackBonus.profaneBonus);
        if (attackBonus.sacredBonus) total += parseInt(attackBonus.sacredBonus);
        if (attackBonus.insightBonus) total += parseInt(attackBonus.insightBonus);
        if (attackBonus.untypedBonus) total += parseInt(attackBonus.untypedBonus);
        if (attackBonus.competenceBonus) total += parseInt(attackBonus.competenceBonus);
        if (attackBonus.feat) total += parseInt(attackBonus.feat);
        
        // Parse misc modifiers from attack bonus
        if (attackBonus.miscModifiers) {
          const numbers = attackBonus.miscModifiers.match(/[+-]?\d+/g) || [];
          const miscTotal = numbers.reduce((sum, num) => sum + parseInt(num), 0);
          total += miscTotal;
        }
        
        if (attackBonus.tempModifiers) {
          const numbers = attackBonus.tempModifiers.match(/[+-]?\d+/g) || [];
          const tempTotal = numbers.reduce((sum, num) => sum + parseInt(num), 0);
          total += tempTotal;
        }
      }

      // Add resolved active buffs (CMB-targeted plus attack-targeted)
      total += buffUtilities.getCmbBuffTotal(this.characterData, this.buffPointTrackers);

      return total;
    },

    getTotalCMB2() {
      let total = 0;
      
      // Add BAB (first number if in "8/3" format)
      if (this.characterData.offense.bab) {
        const babValue = this.characterData.offense.bab.split('/')[0]; // Take first number if format is "8/3"
        total += parseInt(babValue) || 0;
      }
      
      // Add ability modifiers
      total += this.getTotalCMB2AbilityModifier();
      
      // Add size modifier
      if (this.characterData.offense.cmb2 && this.characterData.offense.cmb2.sizeModifier) {
        total += parseInt(this.characterData.offense.cmb2.sizeModifier);
      }
      
      // Parse misc and temp modifiers (text fields)
      if (this.characterData.offense.cmb2 && this.characterData.offense.cmb2.miscModifiers) {
        const numbers = this.characterData.offense.cmb2.miscModifiers.match(/[+-]?\d+/g) || [];
        const miscTotal = numbers.reduce((sum, num) => sum + parseInt(num), 0);
        total += miscTotal;
      }
      
      if (this.characterData.offense.cmb2 && this.characterData.offense.cmb2.tempModifiers) {
        const numbers = this.characterData.offense.cmb2.tempModifiers.match(/[+-]?\d+/g) || [];
        const tempTotal = numbers.reduce((sum, num) => sum + parseInt(num), 0);
        total += tempTotal;
      }
      
      // Add attack bonus fields (excluding enhancement, size, and temp)
      const attackBonus = this.characterData.offense.attackBonus;
      if (attackBonus) {
        if (attackBonus.luckBonus) total += parseInt(attackBonus.luckBonus);
        if (attackBonus.moraleBonus) total += parseInt(attackBonus.moraleBonus);
        if (attackBonus.profaneBonus) total += parseInt(attackBonus.profaneBonus);
        if (attackBonus.sacredBonus) total += parseInt(attackBonus.sacredBonus);
        if (attackBonus.insightBonus) total += parseInt(attackBonus.insightBonus);
        if (attackBonus.untypedBonus) total += parseInt(attackBonus.untypedBonus);
        if (attackBonus.competenceBonus) total += parseInt(attackBonus.competenceBonus);
        if (attackBonus.feat) total += parseInt(attackBonus.feat);
        
        // Parse misc modifiers from attack bonus
        if (attackBonus.miscModifiers) {
          const numbers = attackBonus.miscModifiers.match(/[+-]?\d+/g) || [];
          const miscTotal = numbers.reduce((sum, num) => sum + parseInt(num), 0);
          total += miscTotal;
        }
        if (attackBonus.tempModifiers) {
          const numbers = attackBonus.tempModifiers.match(/[+-]?\d+/g) || [];
          const tempTotal = numbers.reduce((sum, num) => sum + parseInt(num), 0);
          total += tempTotal;
        }
      }

      // Add resolved active buffs (CMB-targeted plus attack-targeted)
      total += buffUtilities.getCmbBuffTotal(this.characterData, this.buffPointTrackers);

      return total;
    },

    getTotalInitiativeAbilityModifier() {
      let total = 0;
      if (this.characterData.offense.initiative && this.characterData.offense.initiative.abilityModifiers) {
        for (const ability in this.characterData.offense.initiative.abilityModifiers) {
          total += this.getScaledAbilityModifier(this.characterData.offense.initiative.abilityModifiers, ability);
        }
      }
      return total;
    },

    getTotalInitiative() {
      let total = 0;
      
      // Add ability modifiers
      total += this.getTotalInitiativeAbilityModifier();
      
      // Parse misc modifiers (text field)
      if (this.characterData.offense.initiative && this.characterData.offense.initiative.miscModifiers) {
        const numbers = this.characterData.offense.initiative.miscModifiers.match(/[+-]?\d+/g) || [];
        const miscTotal = numbers.reduce((sum, num) => sum + parseInt(num), 0);
        total += miscTotal;
      }
      
      return total;
    },

    addAttack() {
      this.characterData.offense.attacks.push({
        weapon: '',
        attackBonus: 0,
        damageBonusName: '',
        damage: '',
        criticalRange: '19-20',
        criticalMult: 'x2',
        criticalConfirmBonus: 0,
        nonMultipliedDamage: '',
        criticalBonusDamage: '',
        type: 'B',
        notes: '',
        tempAttackModifiers: '',
        tempDamageModifiers: '',
        showInDetails: false
      });
    },

    deleteAttack(index) {
      this.characterData.offense.attacks.splice(index, 1);
    },


    convertTextToNumber(text) {
      if(!text || text.length < 1) text = "";
      const numbers = text.match(/[+-]?\d+/g) || [];
      return numbers.reduce((sum, num) => sum + parseInt(num), 0);
    },

    addSkillRow(section, skillName) {
      const baseSkill = this.characterData.skills[section].find(s => s.name === skillName);
      if (baseSkill) {
        const newSkill = {
          name: skillName,
          ability: baseSkill.ability,
          abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}},
          ranks: 0,
          magic: 0,
          race_trait: 0,
          temp: "",
          notes: "",
          misc: 0,
          classSkill: false,
          canAddMore: true,
          needsSpecific: baseSkill.needsSpecific,
          specific: '',
          inQN: false,
        };
        
        // Find the last instance of this skill and insert after it
        let lastIndex = -1;
        for (let i = this.characterData.skills[section].length - 1; i >= 0; i--) {
          if (this.characterData.skills[section][i].name === skillName) {
            lastIndex = i;
            break;
          }
        }
        
        if (lastIndex !== -1) {
          this.characterData.skills[section].splice(lastIndex + 1, 0, newSkill);
        } else {
          this.characterData.skills[section].push(newSkill);
        }
      }
    },

    removeSkillRow(section, index) {
      this.characterData.skills[section].splice(index, 1);
    },

    isFirstInstance(section, skillName, index) {
      return this.characterData.skills[section].findIndex(s => s.name === skillName) === index;
    },


    getAbilityShortName(ability) {
      const names = {
        strength: 'Str',
        dexterity: 'Dex',
        constitution: 'Con',
        intelligence: 'Int',
        wisdom: 'Wis',
        charisma: 'Cha'
      };
      return names[ability] || ability;
    },



    // Feats and Special Abilities Methods
    addFeatSection() {
      this.characterData.feats.sections.push({
        name: 'New Section',
        color: '#1976d2',
        feats: []
      });
    },
    
    addFeat(sectionIndex) {
      this.characterData.feats.sections[sectionIndex].feats.push({
        level: 1,
        name: 'New Feat',
        type: 'General',
        shortDescription: '',
        longDescription: ''
      });
    },
    
    removeFeat(sectionIndex, itemIndex) {
      this.characterData.feats.sections[sectionIndex].feats.splice(itemIndex, 1);
    },
    
    openFeatDialog(feat) {
      this.selectedFeat = feat;
      this.showFeatDialog = true;
    },
    
    addSpecialAbilitySection() {
      this.characterData.specialAbilities.sections.push({
        name: 'New Section',
        color: '#4caf50',
        abilities: []
      });
    },
    
    addSpecialAbility(sectionIndex) {
      this.characterData.specialAbilities.sections[sectionIndex].abilities.push({
        level: 1,
        name: 'New Ability',
        type: 'Su',
        subsection: '',
        shortDescription: '',
        longDescription: ''
      });
    },
    
    deleteSpecialAbility(sectionIndex, ability) {
      const section = this.characterData.specialAbilities.sections[sectionIndex];
      const index = section.abilities.indexOf(ability);
      if (index > -1) {
        section.abilities.splice(index, 1);
      }
    },
    
    openSpecialAbilityDetails(ability) {
      this.selectedSpecialAbility = ability;
      this.showSpecialAbilityDialog = true;
    },
    
    // Spheres Methods
    addSphereSection() {
      this.characterData.spheres.sections.push({
        name: 'New Section',
        color: '#4caf50',
        spheres: []
      });
    },
    
    addSphere(sectionIndex) {
      this.characterData.spheres.sections[sectionIndex].spheres.push({
        level: 1,
        name: 'New Sphere',
        type: 'Su',
        shortDescription: '',
        longDescription: ''
      });
    },
    
    deleteSphere(sectionIndex, sphere) {
      const section = this.characterData.spheres.sections[sectionIndex];
      const index = section.spheres.indexOf(sphere);
      if (index > -1) {
        section.spheres.splice(index, 1);
      }
    },
    
    openSphereDetails(sphere) {
      this.selectedSphere = sphere;
      this.showSphereDialog = true;
    },
    
    // Section deletion methods
    deleteFeatSection(sectionIndex) {
      this.characterData.feats.sections.splice(sectionIndex, 1);
    },
    
    deleteSpecialAbilitySection(sectionIndex) {
      this.characterData.specialAbilities.sections.splice(sectionIndex, 1);
    },
    
    deleteSphereSection(sectionIndex) {
      this.characterData.spheres.sections.splice(sectionIndex, 1);
    },
    
    toggleDeleteMode() {
      this.deleteMode = !this.deleteMode;
      if (!this.deleteMode) {
        // Sort feats by level when saving
        this.characterData.feats.sections.forEach(section => {
          section.feats.sort((a, b) => a.level - b.level);
        });
        // Sort special abilities by level when saving
        this.characterData.specialAbilities.sections.forEach(section => {
          section.abilities.sort((a, b) => a.level - b.level);
        });
        // Sort spheres by level when saving
        this.characterData.spheres.sections.forEach(section => {
          section.spheres.sort((a, b) => a.level - b.level);
        });
      }
    },

    nextTab() {
      // Character sheet tab order: 0 = Abilities, 1 = Defense, 2 = Offense, 3 = Skills, 4 = Feats, 5 = Equipment, 6 = Notes
      if (this.tab < 6) {
        this.tab++;
      } else {
        this.tab = 0; // Loop back to first tab
      }
    },

    previousTab() {
      // Character sheet tab order: 0 = Abilities, 1 = Defense, 2 = Offense, 3 = Skills, 4 = Feats, 5 = Equipment, 6 = Notes
      if (this.tab > 0) {
        this.tab--;
      } else {
        this.tab = 6; // Loop to last tab
      }
    },

    handleKeyboardShortcuts(event) {
      // Handle Tab key state tracking for character sheet tab navigation
      if (event.type === 'keydown') {
        if (event.key === 'Tab') {
          this.tabKeyPressed = true;
          // Don't prevent default here - let normal Tab behavior work
        } else if (this.tabKeyPressed && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
          event.preventDefault();
          if (event.key === 'ArrowLeft') {
            // Tab + Left Arrow = previous character sheet tab
            this.previousTab();
          } else if (event.key === 'ArrowRight') {
            // Tab + Right Arrow = next character sheet tab
            this.nextTab();
          }
        }
      } else if (event.type === 'keyup') {
        if (event.key === 'Tab') {
          this.tabKeyPressed = false;
        }
      }
    },
   
  }
};
</script>

<style scoped>
.v-text-field input {
  text-align: center;
}

/* Rich Text Editor Textarea Styles */
.rich-text-editor-textarea {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 12px;
  min-height: 200px;
  background-color: antiquewhite;
  color: black;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  overflow-y: auto;
  outline: none;
  direction: ltr;
  text-align: left;
  unicode-bidi: embed;
  resize: vertical;
  width: 100%;
}

.rich-text-editor-textarea:focus {
  border-color: #1976d2;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
}



</style>
